function initMap() {
    const solarData = {
        "type": "FeatureCollection",
        "features": [
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.963937,
                        -37.8152065
                    ]
                },
                "properties": {
                    "iqt": 82,
                    "kw": 2109.576,
                    "postcode": 3000
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.9804594,
                        -37.8161444
                    ]
                },
                "properties": {
                    "iqt": 84,
                    "kw": 720.069,
                    "postcode": 3002
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.9253974,
                        -37.8114504
                    ]
                },
                "properties": {
                    "iqt": 118,
                    "kw": 1677.48,
                    "postcode": 3003
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.9804594,
                        -37.8301583
                    ]
                },
                "properties": {
                    "iqt": 18,
                    "kw": 370.96,
                    "postcode": 3004
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.963937,
                        -37.8245483
                    ]
                },
                "properties": {
                    "iqt": 38,
                    "kw": 1186.465,
                    "postcode": 3006
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.9419122,
                        -37.8170652
                    ]
                },
                "properties": {
                    "iqt": 109,
                    "kw": 1594.805,
                    "postcode": 3008
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.9006313,
                        -37.7960195
                    ]
                },
                "properties": {
                    "iqt": 1026,
                    "kw": 6299.184,
                    "postcode": 3011
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.8456217,
                        -37.8146251
                    ]
                },
                "properties": {
                    "iqt": 1651,
                    "kw": 10441.392,
                    "postcode": 3012
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.8813738,
                        -37.819811
                    ]
                },
                "properties": {
                    "iqt": 1115,
                    "kw": 5723.072,
                    "postcode": 3013
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.8786231,
                        -37.8352097
                    ]
                },
                "properties": {
                    "iqt": 1285,
                    "kw": 6299.291,
                    "postcode": 3015
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.8813738,
                        -37.8571449
                    ]
                },
                "properties": {
                    "iqt": 1231,
                    "kw": 6570.753,
                    "postcode": 3016
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.8126334,
                        -37.859343
                    ]
                },
                "properties": {
                    "iqt": 1390,
                    "kw": 8484.019,
                    "postcode": 3018
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.8566207,
                        -37.7903679
                    ]
                },
                "properties": {
                    "iqt": 622,
                    "kw": 3712.78,
                    "postcode": 3019
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.823628,
                        -37.7791149
                    ]
                },
                "properties": {
                    "iqt": 3652,
                    "kw": 21685.042,
                    "postcode": 3020
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.8016402,
                        -37.7435941
                    ]
                },
                "properties": {
                    "iqt": 4304,
                    "kw": 19841.373,
                    "postcode": 3021
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.7988921,
                        -37.7776716
                    ]
                },
                "properties": {
                    "iqt": 241,
                    "kw": 1204.859,
                    "postcode": 3022
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.7521888,
                        -37.7687064
                    ]
                },
                "properties": {
                    "iqt": 7195,
                    "kw": 37014.643,
                    "postcode": 3023
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.5875645,
                        -37.8706337
                    ]
                },
                "properties": {
                    "iqt": 4945,
                    "kw": 27421.001,
                    "postcode": 3024
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.8346241,
                        -37.8388686
                    ]
                },
                "properties": {
                    "iqt": 1035,
                    "kw": 7414.22,
                    "postcode": 3025
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.7796581,
                        -37.8294185
                    ]
                },
                "properties": {
                    "iqt": 679,
                    "kw": 13273.455,
                    "postcode": 3026
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.7439497,
                        -37.8614859
                    ]
                },
                "properties": {
                    "iqt": 1085,
                    "kw": 5645.615,
                    "postcode": 3027
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.7796581,
                        -37.8760399
                    ]
                },
                "properties": {
                    "iqt": 2744,
                    "kw": 12935.403,
                    "postcode": 3028
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.7082568,
                        -37.8282806
                    ]
                },
                "properties": {
                    "iqt": 19035,
                    "kw": 115288.694,
                    "postcode": 3029
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.6753231,
                        -37.938058
                    ]
                },
                "properties": {
                    "iqt": 14038,
                    "kw": 78773.164,
                    "postcode": 3030
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.9198932,
                        -37.790896
                    ]
                },
                "properties": {
                    "iqt": 803,
                    "kw": 4091.338,
                    "postcode": 3031
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.9006313,
                        -37.7773364
                    ]
                },
                "properties": {
                    "iqt": 1615,
                    "kw": 8267.791,
                    "postcode": 3032
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.8566207,
                        -37.7343192
                    ]
                },
                "properties": {
                    "iqt": 1074,
                    "kw": 5799.817,
                    "postcode": 3033
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.8648709,
                        -37.7628247
                    ]
                },
                "properties": {
                    "iqt": 797,
                    "kw": 3965.642,
                    "postcode": 3034
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.8126334,
                        -37.6912843
                    ]
                },
                "properties": {
                    "iqt": 553,
                    "kw": 3012.935,
                    "postcode": 3036
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.7521888,
                        -37.6940036
                    ]
                },
                "properties": {
                    "iqt": 5225,
                    "kw": 26048.442,
                    "postcode": 3037
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.7906484,
                        -37.7024727
                    ]
                },
                "properties": {
                    "iqt": 2691,
                    "kw": 13874.508,
                    "postcode": 3038
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.9198932,
                        -37.7675363
                    ]
                },
                "properties": {
                    "iqt": 772,
                    "kw": 4069.323,
                    "postcode": 3039
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.9006313,
                        -37.7493029
                    ]
                },
                "properties": {
                    "iqt": 1472,
                    "kw": 8093.41,
                    "postcode": 3040
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.9006313,
                        -37.7306079
                    ]
                },
                "properties": {
                    "iqt": 816,
                    "kw": 4739.162,
                    "postcode": 3041
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.8758725,
                        -37.7245197
                    ]
                },
                "properties": {
                    "iqt": 1152,
                    "kw": 7476.052,
                    "postcode": 3042
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.8786231,
                        -37.7044206
                    ]
                },
                "properties": {
                    "iqt": 1591,
                    "kw": 11396.72,
                    "postcode": 3043
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.9364069,
                        -37.7310813
                    ]
                },
                "properties": {
                    "iqt": 1673,
                    "kw": 7956.756,
                    "postcode": 3044
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.8401227,
                        -37.6679317
                    ]
                },
                "properties": {
                    "iqt": 12,
                    "kw": 819.835,
                    "postcode": 3045
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.9336544,
                        -37.7044261
                    ]
                },
                "properties": {
                    "iqt": 2029,
                    "kw": 9477.055,
                    "postcode": 3046
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.9336544,
                        -37.6763574
                    ]
                },
                "properties": {
                    "iqt": 1488,
                    "kw": 9500.38,
                    "postcode": 3047
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.9226452,
                        -37.6539007
                    ]
                },
                "properties": {
                    "iqt": 1669,
                    "kw": 9316.304,
                    "postcode": 3048
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.8896264,
                        -37.6707522
                    ]
                },
                "properties": {
                    "iqt": 850,
                    "kw": 4556.694,
                    "postcode": 3049
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.9419122,
                        -37.7983816
                    ]
                },
                "properties": {
                    "iqt": 244,
                    "kw": 1673.092,
                    "postcode": 3051
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.9474178,
                        -37.7862363
                    ]
                },
                "properties": {
                    "iqt": 131,
                    "kw": 1471.199,
                    "postcode": 3052
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.9694441,
                        -37.798389
                    ]
                },
                "properties": {
                    "iqt": 153,
                    "kw": 1413.453,
                    "postcode": 3053
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.9694441,
                        -37.7843702
                    ]
                },
                "properties": {
                    "iqt": 384,
                    "kw": 1669.289,
                    "postcode": 3054
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.9419122,
                        -37.761
                    ]
                },
                "properties": {
                    "iqt": 773,
                    "kw": 3433.595,
                    "postcode": 3055
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.9584302,
                        -37.7666099
                    ]
                },
                "properties": {
                    "iqt": 1410,
                    "kw": 7875.587,
                    "postcode": 3056
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.9804594,
                        -37.769412
                    ]
                },
                "properties": {
                    "iqt": 545,
                    "kw": 2694.451,
                    "postcode": 3057
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.9666905,
                        -37.7343488
                    ]
                },
                "properties": {
                    "iqt": 2855,
                    "kw": 15878.474,
                    "postcode": 3058
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.8841246,
                        -37.6454887
                    ]
                },
                "properties": {
                    "iqt": 2451,
                    "kw": 16086.44,
                    "postcode": 3059
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.9666905,
                        -37.6969273
                    ]
                },
                "properties": {
                    "iqt": 864,
                    "kw": 4459.625,
                    "postcode": 3060
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.955677,
                        -37.665113
                    ]
                },
                "properties": {
                    "iqt": 844,
                    "kw": 15527.5,
                    "postcode": 3061
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.944665,
                        -37.6332889
                    ]
                },
                "properties": {
                    "iqt": 71,
                    "kw": 2791.795,
                    "postcode": 3062
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.8401227,
                        -37.5930751
                    ]
                },
                "properties": {
                    "iqt": 81,
                    "kw": 654.535,
                    "postcode": 3063
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.9391595,
                        -37.5424079
                    ]
                },
                "properties": {
                    "iqt": 14394,
                    "kw": 88440.636,
                    "postcode": 3064
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.9804594,
                        -37.7974551
                    ]
                },
                "properties": {
                    "iqt": 306,
                    "kw": 1738.79,
                    "postcode": 3065
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.9873447,
                        -37.8009595
                    ]
                },
                "properties": {
                    "iqt": 230,
                    "kw": 1880.952,
                    "postcode": 3066
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.9983623,
                        -37.8023601
                    ]
                },
                "properties": {
                    "iqt": 245,
                    "kw": 1830.088,
                    "postcode": 3067
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.9887218,
                        -37.7885749
                    ]
                },
                "properties": {
                    "iqt": 1087,
                    "kw": 4961.785,
                    "postcode": 3068
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.9997396,
                        -37.7736132
                    ]
                },
                "properties": {
                    "iqt": 2122,
                    "kw": 9535.728,
                    "postcode": 3070
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.0080039,
                        -37.7600493
                    ]
                },
                "properties": {
                    "iqt": 1304,
                    "kw": 6817.942,
                    "postcode": 3071
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.0107588,
                        -37.7399362
                    ]
                },
                "properties": {
                    "iqt": 2408,
                    "kw": 13622.458,
                    "postcode": 3072
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.0107588,
                        -37.7118644
                    ]
                },
                "properties": {
                    "iqt": 3495,
                    "kw": 17064.939,
                    "postcode": 3073
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.0107588,
                        -37.6837819
                    ]
                },
                "properties": {
                    "iqt": 1794,
                    "kw": 14603.213,
                    "postcode": 3074
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.0107588,
                        -37.6650543
                    ]
                },
                "properties": {
                    "iqt": 1818,
                    "kw": 9264.93,
                    "postcode": 3075
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.016269,
                        -37.6341341
                    ]
                },
                "properties": {
                    "iqt": 3630,
                    "kw": 21482.314,
                    "postcode": 3076
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.0190242,
                        -37.7824868
                    ]
                },
                "properties": {
                    "iqt": 1074,
                    "kw": 6166.317,
                    "postcode": 3078
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.0438252,
                        -37.7698427
                    ]
                },
                "properties": {
                    "iqt": 1149,
                    "kw": 6665.187,
                    "postcode": 3079
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.0438252,
                        -37.7417753
                    ]
                },
                "properties": {
                    "iqt": 999,
                    "kw": 6263.519,
                    "postcode": 3081
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.0658766,
                        -37.6649616
                    ]
                },
                "properties": {
                    "iqt": 2635,
                    "kw": 12754.859,
                    "postcode": 3082
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.0548502,
                        -37.6987006
                    ]
                },
                "properties": {
                    "iqt": 2776,
                    "kw": 14207.266,
                    "postcode": 3083
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.0769045,
                        -37.7436031
                    ]
                },
                "properties": {
                    "iqt": 1997,
                    "kw": 10136.553,
                    "postcode": 3084
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.0769045,
                        -37.7248812
                    ]
                },
                "properties": {
                    "iqt": 1062,
                    "kw": 5097.467,
                    "postcode": 3085
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.0851764,
                        -37.7019248
                    ]
                },
                "properties": {
                    "iqt": 727,
                    "kw": 3538.222,
                    "postcode": 3087
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.1099967,
                        -37.698595
                    ]
                },
                "properties": {
                    "iqt": 2357,
                    "kw": 11886.956,
                    "postcode": 3088
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.1541397,
                        -37.6666174
                    ]
                },
                "properties": {
                    "iqt": 1286,
                    "kw": 7079.514,
                    "postcode": 3089
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.1099967,
                        -37.670486
                    ]
                },
                "properties": {
                    "iqt": 269,
                    "kw": 2109.573,
                    "postcode": 3090
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.1320653,
                        -37.6404295
                    ]
                },
                "properties": {
                    "iqt": 245,
                    "kw": 1860.4,
                    "postcode": 3091
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.112755,
                        -37.7393287
                    ]
                },
                "properties": {
                    "iqt": 340,
                    "kw": 2411.882,
                    "postcode": 3093
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.1237889,
                        -37.7196403
                    ]
                },
                "properties": {
                    "iqt": 754,
                    "kw": 3793.823,
                    "postcode": 3094
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.1706992,
                        -37.7049998
                    ]
                },
                "properties": {
                    "iqt": 2578,
                    "kw": 14308.899,
                    "postcode": 3095
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.1872619,
                        -37.6683887
                    ]
                },
                "properties": {
                    "iqt": 217,
                    "kw": 1116.06,
                    "postcode": 3096
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.2369693,
                        -37.6897828
                    ]
                },
                "properties": {
                    "iqt": 226,
                    "kw": 1516.339,
                    "postcode": 3097
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.2148736,
                        -37.5885255
                    ]
                },
                "properties": {
                    "iqt": 622,
                    "kw": 3417.824,
                    "postcode": 3099
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.0328017,
                        -37.803516
                    ]
                },
                "properties": {
                    "iqt": 1340,
                    "kw": 8390.551,
                    "postcode": 3101
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.0548502,
                        -37.7922797
                    ]
                },
                "properties": {
                    "iqt": 459,
                    "kw": 2455.293,
                    "postcode": 3102
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.0769045,
                        -37.8090918
                    ]
                },
                "properties": {
                    "iqt": 962,
                    "kw": 5307.957,
                    "postcode": 3103
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.0879338,
                        -37.7941151
                    ]
                },
                "properties": {
                    "iqt": 1425,
                    "kw": 8569.104,
                    "postcode": 3104
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.0879338,
                        -37.7660476
                    ]
                },
                "properties": {
                    "iqt": 811,
                    "kw": 4195.604,
                    "postcode": 3105
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.1486206,
                        -37.7537669
                    ]
                },
                "properties": {
                    "iqt": 1599,
                    "kw": 8950.267,
                    "postcode": 3106
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.1099967,
                        -37.7641408
                    ]
                },
                "properties": {
                    "iqt": 1022,
                    "kw": 5388.433,
                    "postcode": 3107
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.1210303,
                        -37.7865824
                    ]
                },
                "properties": {
                    "iqt": 1587,
                    "kw": 8750.605,
                    "postcode": 3108
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.1541397,
                        -37.7883929
                    ]
                },
                "properties": {
                    "iqt": 2145,
                    "kw": 11458.697,
                    "postcode": 3109
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.1872619,
                        -37.7901921
                    ]
                },
                "properties": {
                    "iqt": 1247,
                    "kw": 7173.912,
                    "postcode": 3111
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.2148736,
                        -37.7386037
                    ]
                },
                "properties": {
                    "iqt": 992,
                    "kw": 5658.924,
                    "postcode": 3113
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.2148736,
                        -37.7760752
                    ]
                },
                "properties": {
                    "iqt": 415,
                    "kw": 2688.133,
                    "postcode": 3114
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.2590707,
                        -37.7347069
                    ]
                },
                "properties": {
                    "iqt": 450,
                    "kw": 2940.992,
                    "postcode": 3115
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.3088196,
                        -37.7373267
                    ]
                },
                "properties": {
                    "iqt": 1249,
                    "kw": 7011.101,
                    "postcode": 3116
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.9997396,
                        -37.8203499
                    ]
                },
                "properties": {
                    "iqt": 1001,
                    "kw": 5891.279,
                    "postcode": 3121
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.0328017,
                        -37.8222114
                    ]
                },
                "properties": {
                    "iqt": 746,
                    "kw": 4601.069,
                    "postcode": 3122
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.0520938,
                        -37.8310813
                    ]
                },
                "properties": {
                    "iqt": 589,
                    "kw": 3606.7,
                    "postcode": 3123
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.0658766,
                        -37.8334095
                    ]
                },
                "properties": {
                    "iqt": 1306,
                    "kw": 7551.902,
                    "postcode": 3124
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.1099967,
                        -37.8483275
                    ]
                },
                "properties": {
                    "iqt": 1006,
                    "kw": 5127.888,
                    "postcode": 3125
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.0741474,
                        -37.8245223
                    ]
                },
                "properties": {
                    "iqt": 429,
                    "kw": 2747.6,
                    "postcode": 3126
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.0989646,
                        -37.8259003
                    ]
                },
                "properties": {
                    "iqt": 1231,
                    "kw": 6146.937,
                    "postcode": 3127
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.1210303,
                        -37.8333543
                    ]
                },
                "properties": {
                    "iqt": 1128,
                    "kw": 6681.541,
                    "postcode": 3128
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.1210303,
                        -37.8052948
                    ]
                },
                "properties": {
                    "iqt": 1228,
                    "kw": 6062.049,
                    "postcode": 3129
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.1541397,
                        -37.8258214
                    ]
                },
                "properties": {
                    "iqt": 2645,
                    "kw": 13675.552,
                    "postcode": 3130
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.1762197,
                        -37.8239091
                    ]
                },
                "properties": {
                    "iqt": 1951,
                    "kw": 11242.533,
                    "postcode": 3131
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.1983055,
                        -37.8219905
                    ]
                },
                "properties": {
                    "iqt": 1265,
                    "kw": 6707.982,
                    "postcode": 3132
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.1983055,
                        -37.8500602
                    ]
                },
                "properties": {
                    "iqt": 2386,
                    "kw": 12029.345,
                    "postcode": 3133
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.2424941,
                        -37.7900435
                    ]
                },
                "properties": {
                    "iqt": 2841,
                    "kw": 17330.617,
                    "postcode": 3134
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.2535448,
                        -37.8218486
                    ]
                },
                "properties": {
                    "iqt": 1744,
                    "kw": 9490.89,
                    "postcode": 3135
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.2811778,
                        -37.7983502
                    ]
                },
                "properties": {
                    "iqt": 4155,
                    "kw": 21033.201,
                    "postcode": 3136
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.3198788,
                        -37.8253798
                    ]
                },
                "properties": {
                    "iqt": 1596,
                    "kw": 9916.523,
                    "postcode": 3137
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.3309395,
                        -37.7822365
                    ]
                },
                "properties": {
                    "iqt": 2305,
                    "kw": 10892.837,
                    "postcode": 3138
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.5579927,
                        -37.8251456
                    ]
                },
                "properties": {
                    "iqt": 1883,
                    "kw": 11813.229,
                    "postcode": 3139
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.3475331,
                        -37.7643547
                    ]
                },
                "properties": {
                    "iqt": 1833,
                    "kw": 10818.139,
                    "postcode": 3140
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.9914761,
                        -37.838568
                    ]
                },
                "properties": {
                    "iqt": 348,
                    "kw": 2105.661,
                    "postcode": 3141
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.0190242,
                        -37.8432402
                    ]
                },
                "properties": {
                    "iqt": 351,
                    "kw": 2927.736,
                    "postcode": 3142
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.0190242,
                        -37.857253
                    ]
                },
                "properties": {
                    "iqt": 299,
                    "kw": 1852.263,
                    "postcode": 3143
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.0355574,
                        -37.8535148
                    ]
                },
                "properties": {
                    "iqt": 517,
                    "kw": 3629.468,
                    "postcode": 3144
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.0548502,
                        -37.8763981
                    ]
                },
                "properties": {
                    "iqt": 1292,
                    "kw": 6902.274,
                    "postcode": 3145
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.0548502,
                        -37.8577136
                    ]
                },
                "properties": {
                    "iqt": 1521,
                    "kw": 8573.74,
                    "postcode": 3146
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.0906914,
                        -37.8675054
                    ]
                },
                "properties": {
                    "iqt": 1189,
                    "kw": 6118.788,
                    "postcode": 3147
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.0989646,
                        -37.8819831
                    ]
                },
                "properties": {
                    "iqt": 628,
                    "kw": 2916.51,
                    "postcode": 3148
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.1265477,
                        -37.8772869
                    ]
                },
                "properties": {
                    "iqt": 3127,
                    "kw": 16338.021,
                    "postcode": 3149
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.1706992,
                        -37.8921876
                    ]
                },
                "properties": {
                    "iqt": 6012,
                    "kw": 30870.741,
                    "postcode": 3150
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.1513801,
                        -37.8552869
                    ]
                },
                "properties": {
                    "iqt": 1072,
                    "kw": 4856.388,
                    "postcode": 3151
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.220397,
                        -37.8668518
                    ]
                },
                "properties": {
                    "iqt": 3718,
                    "kw": 19555.157,
                    "postcode": 3152
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.2756505,
                        -37.8386354
                    ]
                },
                "properties": {
                    "iqt": 2310,
                    "kw": 17936.948,
                    "postcode": 3153
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.3198788,
                        -37.8534742
                    ]
                },
                "properties": {
                    "iqt": 441,
                    "kw": 2191.723,
                    "postcode": 3154
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.2867055,
                        -37.8610682
                    ]
                },
                "properties": {
                    "iqt": 2190,
                    "kw": 10924.023,
                    "postcode": 3155
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.3032906,
                        -37.9368007
                    ]
                },
                "properties": {
                    "iqt": 4318,
                    "kw": 22420.332,
                    "postcode": 3156
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.3309395,
                        -37.9039829
                    ]
                },
                "properties": {
                    "iqt": 589,
                    "kw": 3071.541,
                    "postcode": 3158
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.3862638,
                        -37.9225135
                    ]
                },
                "properties": {
                    "iqt": 239,
                    "kw": 1175.34,
                    "postcode": 3159
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.3475331,
                        -37.932935
                    ]
                },
                "properties": {
                    "iqt": 810,
                    "kw": 4320.813,
                    "postcode": 3160
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.0190242,
                        -37.8712631
                    ]
                },
                "properties": {
                    "iqt": 582,
                    "kw": 4107.904,
                    "postcode": 3161
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.0217795,
                        -37.8932076
                    ]
                },
                "properties": {
                    "iqt": 960,
                    "kw": 5733.6,
                    "postcode": 3162
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.0548502,
                        -37.8950779
                    ]
                },
                "properties": {
                    "iqt": 1573,
                    "kw": 7899.104,
                    "postcode": 3163
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        133.775136,
                        -25.274398
                    ]
                },
                "properties": {
                    "iqt": 21,
                    "kw": 550.2,
                    "postcode": 3164
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.0658766,
                        -37.9174873
                    ]
                },
                "properties": {
                    "iqt": 1936,
                    "kw": 10076.78,
                    "postcode": 3165
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.0989646,
                        -37.9006677
                    ]
                },
                "properties": {
                    "iqt": 1508,
                    "kw": 8737.609,
                    "postcode": 3166
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.0989646,
                        -37.9193474
                    ]
                },
                "properties": {
                    "iqt": 810,
                    "kw": 5183.228,
                    "postcode": 3167
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.1320653,
                        -37.9211962
                    ]
                },
                "properties": {
                    "iqt": 883,
                    "kw": 7079.965,
                    "postcode": 3168
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.1210303,
                        -37.9454838
                    ]
                },
                "properties": {
                    "iqt": 1584,
                    "kw": 9280.689,
                    "postcode": 3169
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.1762197,
                        -37.9267579
                    ]
                },
                "properties": {
                    "iqt": 1939,
                    "kw": 12124.072,
                    "postcode": 3170
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.1541397,
                        -37.9473307
                    ]
                },
                "properties": {
                    "iqt": 1869,
                    "kw": 11006.19,
                    "postcode": 3171
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.1320653,
                        -37.9772192
                    ]
                },
                "properties": {
                    "iqt": 2227,
                    "kw": 12117.701,
                    "postcode": 3172
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.1706992,
                        -38.0042683
                    ]
                },
                "properties": {
                    "iqt": 3825,
                    "kw": 22860.851,
                    "postcode": 3173
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.1762197,
                        -37.9641212
                    ]
                },
                "properties": {
                    "iqt": 2926,
                    "kw": 14930.003,
                    "postcode": 3174
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.2148736,
                        -38.0191689
                    ]
                },
                "properties": {
                    "iqt": 4444,
                    "kw": 44536.664,
                    "postcode": 3175
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        133.775136,
                        -25.274398
                    ]
                },
                "properties": {
                    "iqt": 1,
                    "kw": 5.1,
                    "postcode": 3176
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.2424941,
                        -37.9957951
                    ]
                },
                "properties": {
                    "iqt": 946,
                    "kw": 4512.332,
                    "postcode": 3177
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.2424941,
                        -37.9210442
                    ]
                },
                "properties": {
                    "iqt": 4376,
                    "kw": 21623.438,
                    "postcode": 3178
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.220397,
                        -37.9042587
                    ]
                },
                "properties": {
                    "iqt": 705,
                    "kw": 5186.933,
                    "postcode": 3179
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.250782,
                        -37.8887649
                    ]
                },
                "properties": {
                    "iqt": 982,
                    "kw": 6031.985,
                    "postcode": 3180
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.996985,
                        -37.8544481
                    ]
                },
                "properties": {
                    "iqt": 440,
                    "kw": 2456.248,
                    "postcode": 3181
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.9777054,
                        -37.8595773
                    ]
                },
                "properties": {
                    "iqt": 429,
                    "kw": 2572.575,
                    "postcode": 3182
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.9997396,
                        -37.8670566
                    ]
                },
                "properties": {
                    "iqt": 512,
                    "kw": 2636.775,
                    "postcode": 3183
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.9859676,
                        -37.878722
                    ]
                },
                "properties": {
                    "iqt": 510,
                    "kw": 2319.845,
                    "postcode": 3184
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.0080039,
                        -37.8862009
                    ]
                },
                "properties": {
                    "iqt": 599,
                    "kw": 3209.561,
                    "postcode": 3185
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.9997396,
                        -37.9044002
                    ]
                },
                "properties": {
                    "iqt": 1328,
                    "kw": 8696.144,
                    "postcode": 3186
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.0190242,
                        -37.9179439
                    ]
                },
                "properties": {
                    "iqt": 1244,
                    "kw": 6799.817,
                    "postcode": 3187
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.0135139,
                        -37.9394031
                    ]
                },
                "properties": {
                    "iqt": 1218,
                    "kw": 6517.639,
                    "postcode": 3188
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.0576067,
                        -37.9403568
                    ]
                },
                "properties": {
                    "iqt": 665,
                    "kw": 5476.076,
                    "postcode": 3189
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.0410692,
                        -37.9487497
                    ]
                },
                "properties": {
                    "iqt": 665,
                    "kw": 3718.103,
                    "postcode": 3190
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.0135139,
                        -37.9533967
                    ]
                },
                "properties": {
                    "iqt": 740,
                    "kw": 4386.205,
                    "postcode": 3191
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.0658766,
                        -37.964155
                    ]
                },
                "properties": {
                    "iqt": 1738,
                    "kw": 11143.813,
                    "postcode": 3192
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.0328017,
                        -37.9809272
                    ]
                },
                "properties": {
                    "iqt": 1607,
                    "kw": 9575.787,
                    "postcode": 3193
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.0741474,
                        -37.9786189
                    ]
                },
                "properties": {
                    "iqt": 835,
                    "kw": 5396.187,
                    "postcode": 3194
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.1044805,
                        -38.0005492
                    ]
                },
                "properties": {
                    "iqt": 3520,
                    "kw": 24665.388,
                    "postcode": 3195
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.1210303,
                        -38.048116
                    ]
                },
                "properties": {
                    "iqt": 2286,
                    "kw": 11225.474,
                    "postcode": 3196
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.1431018,
                        -38.0742262
                    ]
                },
                "properties": {
                    "iqt": 1254,
                    "kw": 5587.821,
                    "postcode": 3197
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.1431018,
                        -38.1021858
                    ]
                },
                "properties": {
                    "iqt": 1786,
                    "kw": 9201.334,
                    "postcode": 3198
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.1486206,
                        -38.1645944
                    ]
                },
                "properties": {
                    "iqt": 5215,
                    "kw": 26468.121,
                    "postcode": 3199
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.162419,
                        -38.1250223
                    ]
                },
                "properties": {
                    "iqt": 432,
                    "kw": 1788.285,
                    "postcode": 3200
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.1706992,
                        -38.0975353
                    ]
                },
                "properties": {
                    "iqt": 2738,
                    "kw": 17326.277,
                    "postcode": 3201
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.0879338,
                        -37.9529597
                    ]
                },
                "properties": {
                    "iqt": 244,
                    "kw": 2071.346,
                    "postcode": 3202
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.0438252,
                        -37.9193526
                    ]
                },
                "properties": {
                    "iqt": 2022,
                    "kw": 11152.712,
                    "postcode": 3204
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.963937,
                        -37.8338889
                    ]
                },
                "properties": {
                    "iqt": 297,
                    "kw": 2218.289,
                    "postcode": 3205
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.9584302,
                        -37.8460268
                    ]
                },
                "properties": {
                    "iqt": 425,
                    "kw": 2156.294,
                    "postcode": 3206
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.9226452,
                        -37.8315264
                    ]
                },
                "properties": {
                    "iqt": 495,
                    "kw": 4987.406,
                    "postcode": 3207
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.4561033,
                        -37.9368044
                    ]
                },
                "properties": {
                    "iqt": 252,
                    "kw": 1756.665,
                    "postcode": 3211
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.4561033,
                        -38.0110859
                    ]
                },
                "properties": {
                    "iqt": 2457,
                    "kw": 12919.397,
                    "postcode": 3212
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.2811537,
                        -37.9873525
                    ]
                },
                "properties": {
                    "iqt": 570,
                    "kw": 4283.952,
                    "postcode": 3213
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.3576473,
                        -38.0788809
                    ]
                },
                "properties": {
                    "iqt": 2456,
                    "kw": 11348.738,
                    "postcode": 3214
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.3357845,
                        -38.1083132
                    ]
                },
                "properties": {
                    "iqt": 1983,
                    "kw": 11948.698,
                    "postcode": 3215
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.3139277,
                        -38.1747227
                    ]
                },
                "properties": {
                    "iqt": 6408,
                    "kw": 32227.211,
                    "postcode": 3216
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.3248554,
                        -38.2617284
                    ]
                },
                "properties": {
                    "iqt": 1788,
                    "kw": 11713.854,
                    "postcode": 3217
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.2047333,
                        -38.1180538
                    ]
                },
                "properties": {
                    "iqt": 1187,
                    "kw": 6549.023,
                    "postcode": 3218
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.3849841,
                        -38.176358
                    ]
                },
                "properties": {
                    "iqt": 2187,
                    "kw": 10432.293,
                    "postcode": 3219
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.3521811,
                        -38.155681
                    ]
                },
                "properties": {
                    "iqt": 1475,
                    "kw": 11663.759,
                    "postcode": 3220
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.1501922,
                        -38.1636337
                    ]
                },
                "properties": {
                    "iqt": 479,
                    "kw": 1871.861,
                    "postcode": 3221
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.5875645,
                        -38.2049453
                    ]
                },
                "properties": {
                    "iqt": 2726,
                    "kw": 15202.14,
                    "postcode": 3222
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.6753231,
                        -38.1610488
                    ]
                },
                "properties": {
                    "iqt": 1815,
                    "kw": 9279.351,
                    "postcode": 3223
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.4451578,
                        -38.1833957
                    ]
                },
                "properties": {
                    "iqt": 1940,
                    "kw": 10363.114,
                    "postcode": 3224
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.5985292,
                        -38.2735587
                    ]
                },
                "properties": {
                    "iqt": 1107,
                    "kw": 5647.704,
                    "postcode": 3225
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.5382417,
                        -38.2573292
                    ]
                },
                "properties": {
                    "iqt": 2696,
                    "kw": 13580.179,
                    "postcode": 3226
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.4232713,
                        -38.2498059
                    ]
                },
                "properties": {
                    "iqt": 976,
                    "kw": 5291.893,
                    "postcode": 3227
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.2374759,
                        -38.3419249
                    ]
                },
                "properties": {
                    "iqt": 3291,
                    "kw": 19059.573,
                    "postcode": 3228
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.1501922,
                        -38.3850062
                    ]
                },
                "properties": {
                    "iqt": 726,
                    "kw": 3891.591,
                    "postcode": 3230
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.0521131,
                        -38.451657
                    ]
                },
                "properties": {
                    "iqt": 442,
                    "kw": 2349.298,
                    "postcode": 3231
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        143.9324048,
                        -38.528668
                    ]
                },
                "properties": {
                    "iqt": 176,
                    "kw": 1028.128,
                    "postcode": 3232
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        143.6285244,
                        -38.7494709
                    ]
                },
                "properties": {
                    "iqt": 444,
                    "kw": 2765.422,
                    "postcode": 3233
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        143.8454596,
                        -38.6077436
                    ]
                },
                "properties": {
                    "iqt": 55,
                    "kw": 389.995,
                    "postcode": 3234
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        143.9324048,
                        -38.455233
                    ]
                },
                "properties": {
                    "iqt": 101,
                    "kw": 583.725,
                    "postcode": 3235
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        143.7043819,
                        -38.5115754
                    ]
                },
                "properties": {
                    "iqt": 63,
                    "kw": 281.125,
                    "postcode": 3236
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        143.4554195,
                        -38.6505708
                    ]
                },
                "properties": {
                    "iqt": 44,
                    "kw": 419.492,
                    "postcode": 3237
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        143.4122052,
                        -38.7443167
                    ]
                },
                "properties": {
                    "iqt": 60,
                    "kw": 313.04,
                    "postcode": 3238
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        143.4122052,
                        -38.5619202
                    ]
                },
                "properties": {
                    "iqt": 75,
                    "kw": 487.6,
                    "postcode": 3239
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.1283863,
                        -38.2482932
                    ]
                },
                "properties": {
                    "iqt": 401,
                    "kw": 2385.596,
                    "postcode": 3240
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        143.9541563,
                        -38.260588
                    ]
                },
                "properties": {
                    "iqt": 458,
                    "kw": 2856.013,
                    "postcode": 3241
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        143.8128803,
                        -38.3300725
                    ]
                },
                "properties": {
                    "iqt": 174,
                    "kw": 982.395,
                    "postcode": 3242
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        143.8020236,
                        -38.4455968
                    ]
                },
                "properties": {
                    "iqt": 61,
                    "kw": 347.56,
                    "postcode": 3243
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        143.4338092,
                        -38.36853
                    ]
                },
                "properties": {
                    "iqt": 465,
                    "kw": 2852.56,
                    "postcode": 3249
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        143.5852111,
                        -38.3313559
                    ]
                },
                "properties": {
                    "iqt": 1231,
                    "kw": 6931.288,
                    "postcode": 3250
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        143.6718623,
                        -38.1418099
                    ]
                },
                "properties": {
                    "iqt": 71,
                    "kw": 342.405,
                    "postcode": 3251
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        143.5256956,
                        -38.2962142
                    ]
                },
                "properties": {
                    "iqt": 61,
                    "kw": 377.41,
                    "postcode": 3254
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        143.1319209,
                        -38.1491105
                    ]
                },
                "properties": {
                    "iqt": 526,
                    "kw": 3853.815,
                    "postcode": 3260
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        142.8955875,
                        -38.2273268
                    ]
                },
                "properties": {
                    "iqt": 270,
                    "kw": 2038.41,
                    "postcode": 3264
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        142.7455935,
                        -38.2633053
                    ]
                },
                "properties": {
                    "iqt": 375,
                    "kw": 4336.501,
                    "postcode": 3265
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        143.1534436,
                        -38.3948462
                    ]
                },
                "properties": {
                    "iqt": 383,
                    "kw": 3348.657,
                    "postcode": 3266
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        143.0781416,
                        -38.467729
                    ]
                },
                "properties": {
                    "iqt": 28,
                    "kw": 230.975,
                    "postcode": 3267
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        142.9385002,
                        -38.4984954
                    ]
                },
                "properties": {
                    "iqt": 357,
                    "kw": 3276.185,
                    "postcode": 3268
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        143.1104044,
                        -38.6344019
                    ]
                },
                "properties": {
                    "iqt": 106,
                    "kw": 852.202,
                    "postcode": 3269
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        142.8793838,
                        -38.5949819
                    ]
                },
                "properties": {
                    "iqt": 37,
                    "kw": 201.535,
                    "postcode": 3270
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        143.0029169,
                        -37.9185598
                    ]
                },
                "properties": {
                    "iqt": 42,
                    "kw": 325.465,
                    "postcode": 3271
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        142.8312661,
                        -38.002399
                    ]
                },
                "properties": {
                    "iqt": 252,
                    "kw": 1589.01,
                    "postcode": 3272
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        142.6814062,
                        -37.9654484
                    ]
                },
                "properties": {
                    "iqt": 19,
                    "kw": 120.27,
                    "postcode": 3273
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        142.5105224,
                        -37.9386771
                    ]
                },
                "properties": {
                    "iqt": 43,
                    "kw": 215.13,
                    "postcode": 3274
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        142.4625357,
                        -38.2901504
                    ]
                },
                "properties": {
                    "iqt": 48,
                    "kw": 252.191,
                    "postcode": 3275
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        142.4891909,
                        -38.0951382
                    ]
                },
                "properties": {
                    "iqt": 60,
                    "kw": 476.79,
                    "postcode": 3276
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        142.6814062,
                        -38.4034955
                    ]
                },
                "properties": {
                    "iqt": 198,
                    "kw": 1795.67,
                    "postcode": 3277
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        142.6065939,
                        -38.2755738
                    ]
                },
                "properties": {
                    "iqt": 54,
                    "kw": 391.92,
                    "postcode": 3278
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        142.6279608,
                        -38.1923617
                    ]
                },
                "properties": {
                    "iqt": 36,
                    "kw": 198.59,
                    "postcode": 3279
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        142.4678659,
                        -38.3603292
                    ]
                },
                "properties": {
                    "iqt": 2756,
                    "kw": 16396.876,
                    "postcode": 3280
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        142.5532048,
                        -38.2466034
                    ]
                },
                "properties": {
                    "iqt": 271,
                    "kw": 2080.358,
                    "postcode": 3281
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        142.3719834,
                        -38.2971689
                    ]
                },
                "properties": {
                    "iqt": 281,
                    "kw": 1692.029,
                    "postcode": 3282
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        142.2337184,
                        -38.2179522
                    ]
                },
                "properties": {
                    "iqt": 186,
                    "kw": 1246.182,
                    "postcode": 3283
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        142.2007574,
                        -38.3689713
                    ]
                },
                "properties": {
                    "iqt": 447,
                    "kw": 2803.031,
                    "postcode": 3284
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        141.9822579,
                        -38.2498873
                    ]
                },
                "properties": {
                    "iqt": 178,
                    "kw": 960.528,
                    "postcode": 3285
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        141.9791849,
                        -38.0490245
                    ]
                },
                "properties": {
                    "iqt": 73,
                    "kw": 459.446,
                    "postcode": 3286
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        142.2974988,
                        -38.0416972
                    ]
                },
                "properties": {
                    "iqt": 50,
                    "kw": 277.512,
                    "postcode": 3287
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        142.318772,
                        -37.8854097
                    ]
                },
                "properties": {
                    "iqt": 122,
                    "kw": 685.752,
                    "postcode": 3289
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        141.1198886,
                        -38.0625136
                    ]
                },
                "properties": {
                    "iqt": 61,
                    "kw": 286.22,
                    "postcode": 3292
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        142.5745556,
                        -37.7609742
                    ]
                },
                "properties": {
                    "iqt": 49,
                    "kw": 216.906,
                    "postcode": 3293
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        142.318772,
                        -37.6658132
                    ]
                },
                "properties": {
                    "iqt": 135,
                    "kw": 874.874,
                    "postcode": 3294
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        142.0003599,
                        -37.783845
                    ]
                },
                "properties": {
                    "iqt": 1027,
                    "kw": 6237.812,
                    "postcode": 3300
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        141.8945505,
                        -37.7255033
                    ]
                },
                "properties": {
                    "iqt": 146,
                    "kw": 827.017,
                    "postcode": 3301
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        141.8100218,
                        -37.8391588
                    ]
                },
                "properties": {
                    "iqt": 52,
                    "kw": 294.185,
                    "postcode": 3302
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        141.5570726,
                        -37.9603082
                    ]
                },
                "properties": {
                    "iqt": 37,
                    "kw": 312.915,
                    "postcode": 3303
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        141.3889736,
                        -37.9678788
                    ]
                },
                "properties": {
                    "iqt": 421,
                    "kw": 2391.738,
                    "postcode": 3304
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        141.4706543,
                        -38.290126
                    ]
                },
                "properties": {
                    "iqt": 1730,
                    "kw": 8963.763,
                    "postcode": 3305
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        141.5360368,
                        -37.7888212
                    ]
                },
                "properties": {
                    "iqt": 15,
                    "kw": 85.4,
                    "postcode": 3309
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        141.5781151,
                        -37.7322539
                    ]
                },
                "properties": {
                    "iqt": 43,
                    "kw": 215.535,
                    "postcode": 3310
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        141.2841298,
                        -37.5824909
                    ]
                },
                "properties": {
                    "iqt": 236,
                    "kw": 1211.727,
                    "postcode": 3311
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        141.095836,
                        -37.382002
                    ]
                },
                "properties": {
                    "iqt": 125,
                    "kw": 687.525,
                    "postcode": 3312
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        142.0639245,
                        -37.4235761
                    ]
                },
                "properties": {
                    "iqt": 88,
                    "kw": 509.741,
                    "postcode": 3314
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        141.7255991,
                        -37.4420537
                    ]
                },
                "properties": {
                    "iqt": 233,
                    "kw": 1257.695,
                    "postcode": 3315
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        141.5781151,
                        -37.1477475
                    ]
                },
                "properties": {
                    "iqt": 25,
                    "kw": 169.1,
                    "postcode": 3317
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        141.3050851,
                        -37.0613621
                    ]
                },
                "properties": {
                    "iqt": 222,
                    "kw": 1464.231,
                    "postcode": 3318
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        141.0540674,
                        -36.8910613
                    ]
                },
                "properties": {
                    "iqt": 53,
                    "kw": 292.586,
                    "postcode": 3319
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        143.9541563,
                        -38.1130535
                    ]
                },
                "properties": {
                    "iqt": 297,
                    "kw": 1688.695,
                    "postcode": 3321
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        143.6285244,
                        -38.0526438
                    ]
                },
                "properties": {
                    "iqt": 19,
                    "kw": 90.74,
                    "postcode": 3322
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        143.4986586,
                        -38.0061194
                    ]
                },
                "properties": {
                    "iqt": 6,
                    "kw": 48.72,
                    "postcode": 3323
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        143.3474304,
                        -37.8964298
                    ]
                },
                "properties": {
                    "iqt": 107,
                    "kw": 574.76,
                    "postcode": 3324
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        143.1749726,
                        -37.9076784
                    ]
                },
                "properties": {
                    "iqt": 99,
                    "kw": 690.53,
                    "postcode": 3325
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.0630048,
                        -38.022066
                    ]
                },
                "properties": {
                    "iqt": 374,
                    "kw": 2008.477,
                    "postcode": 3328
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        143.88892,
                        -37.9976266
                    ]
                },
                "properties": {
                    "iqt": 35,
                    "kw": 156.2,
                    "postcode": 3329
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        143.7152249,
                        -37.9359743
                    ]
                },
                "properties": {
                    "iqt": 28,
                    "kw": 152.79,
                    "postcode": 3330
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.1938221,
                        -37.9939081
                    ]
                },
                "properties": {
                    "iqt": 1136,
                    "kw": 6468.16,
                    "postcode": 3331
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.1065864,
                        -37.9633341
                    ]
                },
                "properties": {
                    "iqt": 189,
                    "kw": 1391.899,
                    "postcode": 3332
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.0194472,
                        -37.8585983
                    ]
                },
                "properties": {
                    "iqt": 146,
                    "kw": 1101.242,
                    "postcode": 3333
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.0630048,
                        -37.7625944
                    ]
                },
                "properties": {
                    "iqt": 74,
                    "kw": 424.691,
                    "postcode": 3334
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.6528671,
                        -37.7304074
                    ]
                },
                "properties": {
                    "iqt": 2010,
                    "kw": 12970.458,
                    "postcode": 3335
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.6625371,
                        -37.7215185
                    ]
                },
                "properties": {
                    "iqt": 2121,
                    "kw": 14342.265,
                    "postcode": 3336
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.5875645,
                        -37.6095412
                    ]
                },
                "properties": {
                    "iqt": 4982,
                    "kw": 25577.143,
                    "postcode": 3337
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.5437205,
                        -37.7810237
                    ]
                },
                "properties": {
                    "iqt": 4828,
                    "kw": 27545.146,
                    "postcode": 3338
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.4123303,
                        -37.7356162
                    ]
                },
                "properties": {
                    "iqt": 3201,
                    "kw": 17139.334,
                    "postcode": 3340
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.3248554,
                        -37.5934691
                    ]
                },
                "properties": {
                    "iqt": 281,
                    "kw": 1415.872,
                    "postcode": 3341
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.215646,
                        -37.6114047
                    ]
                },
                "properties": {
                    "iqt": 646,
                    "kw": 3525.481,
                    "postcode": 3342
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.1174856,
                        -37.5678296
                    ]
                },
                "properties": {
                    "iqt": 266,
                    "kw": 1453.604,
                    "postcode": 3345
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        143.8563224,
                        -37.5691087
                    ]
                },
                "properties": {
                    "iqt": 6038,
                    "kw": 36622.515,
                    "postcode": 3350
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        143.0029169,
                        -37.6978029
                    ]
                },
                "properties": {
                    "iqt": 1492,
                    "kw": 8247.738,
                    "postcode": 3351
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        143.8671868,
                        -37.7122033
                    ]
                },
                "properties": {
                    "iqt": 2810,
                    "kw": 17548.602,
                    "postcode": 3352
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        133.775136,
                        -25.274398
                    ]
                },
                "properties": {
                    "iqt": 11,
                    "kw": 27.84,
                    "postcode": 3353
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        133.775136,
                        -25.274398
                    ]
                },
                "properties": {
                    "iqt": 1,
                    "kw": 4,
                    "postcode": 3354
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        143.7911684,
                        -37.5089149
                    ]
                },
                "properties": {
                    "iqt": 1251,
                    "kw": 9154.993,
                    "postcode": 3355
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        143.8183092,
                        -37.5881949
                    ]
                },
                "properties": {
                    "iqt": 1733,
                    "kw": 10574.248,
                    "postcode": 3356
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        143.8943543,
                        -37.6521937
                    ]
                },
                "properties": {
                    "iqt": 561,
                    "kw": 3059.623,
                    "postcode": 3357
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        143.7965958,
                        -37.5805158
                    ]
                },
                "properties": {
                    "iqt": 201,
                    "kw": 1386.89,
                    "postcode": 3358
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        143.5202874,
                        -37.7370214
                    ]
                },
                "properties": {
                    "iqt": 132,
                    "kw": 669.625,
                    "postcode": 3360
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        143.3474304,
                        -37.7488709
                    ]
                },
                "properties": {
                    "iqt": 106,
                    "kw": 634.37,
                    "postcode": 3361
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        143.8780526,
                        -37.409312
                    ]
                },
                "properties": {
                    "iqt": 655,
                    "kw": 3973.854,
                    "postcode": 3363
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        143.9541563,
                        -37.3708363
                    ]
                },
                "properties": {
                    "iqt": 428,
                    "kw": 2540.616,
                    "postcode": 3364
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        143.8020236,
                        -37.261355
                    ]
                },
                "properties": {
                    "iqt": 408,
                    "kw": 2181.14,
                    "postcode": 3370
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        143.6718623,
                        -37.2153546
                    ]
                },
                "properties": {
                    "iqt": 280,
                    "kw": 1369.665,
                    "postcode": 3371
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        143.3474304,
                        -37.4528631
                    ]
                },
                "properties": {
                    "iqt": 459,
                    "kw": 2719.292,
                    "postcode": 3373
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        142.8955875,
                        -37.1596728
                    ]
                },
                "properties": {
                    "iqt": 87,
                    "kw": 658.175,
                    "postcode": 3374
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        143.1749726,
                        -37.390738
                    ]
                },
                "properties": {
                    "iqt": 27,
                    "kw": 257.98,
                    "postcode": 3375
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        142.9170407,
                        -37.2971613
                    ]
                },
                "properties": {
                    "iqt": 1300,
                    "kw": 7340.387,
                    "postcode": 3377
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        143.0244018,
                        -37.5026752
                    ]
                },
                "properties": {
                    "iqt": 19,
                    "kw": 159.695,
                    "postcode": 3378
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        142.6172766,
                        -37.5195066
                    ]
                },
                "properties": {
                    "iqt": 117,
                    "kw": 643.195,
                    "postcode": 3379
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        142.7777088,
                        -37.0517769
                    ]
                },
                "properties": {
                    "iqt": 784,
                    "kw": 4816.448,
                    "postcode": 3380
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        142.5745556,
                        -37.1716807
                    ]
                },
                "properties": {
                    "iqt": 270,
                    "kw": 1635.158,
                    "postcode": 3381
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        143.0888943,
                        -36.9882754
                    ]
                },
                "properties": {
                    "iqt": 110,
                    "kw": 593.812,
                    "postcode": 3384
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        142.6600232,
                        -36.9066682
                    ]
                },
                "properties": {
                    "iqt": 116,
                    "kw": 602.405,
                    "postcode": 3385
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        142.8312661,
                        -36.8204775
                    ]
                },
                "properties": {
                    "iqt": 68,
                    "kw": 339.26,
                    "postcode": 3387
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        142.6600232,
                        -36.6090828
                    ]
                },
                "properties": {
                    "iqt": 102,
                    "kw": 529.12,
                    "postcode": 3388
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        142.4891909,
                        -36.6209737
                    ]
                },
                "properties": {
                    "iqt": 179,
                    "kw": 911.722,
                    "postcode": 3390
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        142.4252353,
                        -36.0562538
                    ]
                },
                "properties": {
                    "iqt": 32,
                    "kw": 225.675,
                    "postcode": 3391
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        142.5745556,
                        -36.4286658
                    ]
                },
                "properties": {
                    "iqt": 112,
                    "kw": 534.32,
                    "postcode": 3392
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        142.4039296,
                        -36.2167744
                    ]
                },
                "properties": {
                    "iqt": 443,
                    "kw": 2576.98,
                    "postcode": 3393
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        142.4039296,
                        -35.9172982
                    ]
                },
                "properties": {
                    "iqt": 98,
                    "kw": 478.097,
                    "postcode": 3395
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        142.318772,
                        -35.7360202
                    ]
                },
                "properties": {
                    "iqt": 142,
                    "kw": 822.96,
                    "postcode": 3396
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        142.1806128,
                        -36.7204107
                    ]
                },
                "properties": {
                    "iqt": 1886,
                    "kw": 12079.838,
                    "postcode": 3400
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        142.2762322,
                        -36.9503512
                    ]
                },
                "properties": {
                    "iqt": 825,
                    "kw": 5316.256,
                    "postcode": 3401
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        133.775136,
                        -25.274398
                    ]
                },
                "properties": {
                    "iqt": 22,
                    "kw": 75.78,
                    "postcode": 3402
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        141.8100218,
                        -37.2543103
                    ]
                },
                "properties": {
                    "iqt": 67,
                    "kw": 376.148,
                    "postcode": 3407
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        141.8100218,
                        -36.8127092
                    ]
                },
                "properties": {
                    "iqt": 219,
                    "kw": 1048.23,
                    "postcode": 3409
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        141.4939853,
                        -36.6744115
                    ]
                },
                "properties": {
                    "iqt": 58,
                    "kw": 228.85,
                    "postcode": 3412
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        141.2213044,
                        -36.7355842
                    ]
                },
                "properties": {
                    "iqt": 26,
                    "kw": 155.672,
                    "postcode": 3413
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        142.0639245,
                        -36.314886
                    ]
                },
                "properties": {
                    "iqt": 339,
                    "kw": 1586.885,
                    "postcode": 3414
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        141.3784817,
                        -36.3811882
                    ]
                },
                "properties": {
                    "iqt": 3,
                    "kw": 18.46,
                    "postcode": 3415
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        141.5991643,
                        -36.2520776
                    ]
                },
                "properties": {
                    "iqt": 487,
                    "kw": 2460.151,
                    "postcode": 3418
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        141.2213044,
                        -36.3672353
                    ]
                },
                "properties": {
                    "iqt": 158,
                    "kw": 723.072,
                    "postcode": 3419
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        141.095836,
                        -36.0603124
                    ]
                },
                "properties": {
                    "iqt": 54,
                    "kw": 297.935,
                    "postcode": 3420
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        141.9791849,
                        -36.134382
                    ]
                },
                "properties": {
                    "iqt": 84,
                    "kw": 410.329,
                    "postcode": 3423
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        141.9791849,
                        -35.8357024
                    ]
                },
                "properties": {
                    "iqt": 152,
                    "kw": 951.46,
                    "postcode": 3424
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.6862995,
                        -37.6153848
                    ]
                },
                "properties": {
                    "iqt": 756,
                    "kw": 4506.166,
                    "postcode": 3427
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.7961441,
                        -37.6342319
                    ]
                },
                "properties": {
                    "iqt": 109,
                    "kw": 899.546,
                    "postcode": 3428
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.7192376,
                        -37.5424727
                    ]
                },
                "properties": {
                    "iqt": 4718,
                    "kw": 25793.772,
                    "postcode": 3429
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.8071366,
                        -37.497542
                    ]
                },
                "properties": {
                    "iqt": 47,
                    "kw": 344.69,
                    "postcode": 3430
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.6753231,
                        -37.4525468
                    ]
                },
                "properties": {
                    "iqt": 709,
                    "kw": 3857.025,
                    "postcode": 3431
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.7741635,
                        -37.439438
                    ]
                },
                "properties": {
                    "iqt": 41,
                    "kw": 273.245,
                    "postcode": 3432
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.7796581,
                        -37.399104
                    ]
                },
                "properties": {
                    "iqt": 48,
                    "kw": 298.53,
                    "postcode": 3433
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.7192376,
                        -37.3550485
                    ]
                },
                "properties": {
                    "iqt": 893,
                    "kw": 4951.705,
                    "postcode": 3434
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.7192376,
                        -37.2423687
                    ]
                },
                "properties": {
                    "iqt": 559,
                    "kw": 3283.125,
                    "postcode": 3435
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.5437205,
                        -37.5197014
                    ]
                },
                "properties": {
                    "iqt": 1606,
                    "kw": 10513.428,
                    "postcode": 3437
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.620463,
                        -37.4618532
                    ]
                },
                "properties": {
                    "iqt": 332,
                    "kw": 2196.009,
                    "postcode": 3438
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.5546793,
                        -37.4205517
                    ]
                },
                "properties": {
                    "iqt": 265,
                    "kw": 1410.966,
                    "postcode": 3440
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.5985292,
                        -37.3981393
                    ]
                },
                "properties": {
                    "iqt": 153,
                    "kw": 1012.996,
                    "postcode": 3441
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.5437205,
                        -37.3324774
                    ]
                },
                "properties": {
                    "iqt": 1578,
                    "kw": 9087.319,
                    "postcode": 3442
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.5656396,
                        -37.1335012
                    ]
                },
                "properties": {
                    "iqt": 1734,
                    "kw": 10459.179,
                    "postcode": 3444
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.3576473,
                        -37.1840298
                    ]
                },
                "properties": {
                    "iqt": 239,
                    "kw": 1126.757,
                    "postcode": 3446
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.3576473,
                        -37.1465105
                    ]
                },
                "properties": {
                    "iqt": 142,
                    "kw": 704.508,
                    "postcode": 3447
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.3685809,
                        -37.0470063
                    ]
                },
                "properties": {
                    "iqt": 250,
                    "kw": 1217.757,
                    "postcode": 3448
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.2265602,
                        -37.0636472
                    ]
                },
                "properties": {
                    "iqt": 1528,
                    "kw": 6351.655,
                    "postcode": 3450
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.1938221,
                        -37.0991896
                    ]
                },
                "properties": {
                    "iqt": 1231,
                    "kw": 6106.01,
                    "postcode": 3451
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.2374759,
                        -36.9265571
                    ]
                },
                "properties": {
                    "iqt": 478,
                    "kw": 2604.595,
                    "postcode": 3453
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.3685809,
                        -37.459275
                    ]
                },
                "properties": {
                    "iqt": 506,
                    "kw": 2836.15,
                    "postcode": 3458
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.1610974,
                        -37.3405241
                    ]
                },
                "properties": {
                    "iqt": 524,
                    "kw": 3015.306,
                    "postcode": 3460
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.1938221,
                        -37.286475
                    ]
                },
                "properties": {
                    "iqt": 1039,
                    "kw": 5360.461,
                    "postcode": 3461
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.0630048,
                        -37.0911657
                    ]
                },
                "properties": {
                    "iqt": 313,
                    "kw": 1233.197,
                    "postcode": 3462
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        143.9759139,
                        -36.9483008
                    ]
                },
                "properties": {
                    "iqt": 694,
                    "kw": 3232.748,
                    "postcode": 3463
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        143.8454596,
                        -37.0150311
                    ]
                },
                "properties": {
                    "iqt": 227,
                    "kw": 1503.7,
                    "postcode": 3464
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        143.6935405,
                        -37.0550295
                    ]
                },
                "properties": {
                    "iqt": 1812,
                    "kw": 10378.885,
                    "postcode": 3465
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        143.4554195,
                        -37.0638618
                    ]
                },
                "properties": {
                    "iqt": 293,
                    "kw": 1498.976,
                    "postcode": 3467
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        143.4122052,
                        -37.1974706
                    ]
                },
                "properties": {
                    "iqt": 80,
                    "kw": 408.129,
                    "postcode": 3468
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        143.2395973,
                        -37.1727781
                    ]
                },
                "properties": {
                    "iqt": 65,
                    "kw": 393.78,
                    "postcode": 3469
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        143.6068646,
                        -36.8747643
                    ]
                },
                "properties": {
                    "iqt": 403,
                    "kw": 1754.825,
                    "postcode": 3472
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        143.5202874,
                        -36.6942531
                    ]
                },
                "properties": {
                    "iqt": 88,
                    "kw": 404.79,
                    "postcode": 3475
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        143.1749726,
                        -36.7208653
                    ]
                },
                "properties": {
                    "iqt": 181,
                    "kw": 951.568,
                    "postcode": 3477
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        143.2827118,
                        -37.0021242
                    ]
                },
                "properties": {
                    "iqt": 500,
                    "kw": 3040.544,
                    "postcode": 3478
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        142.9170407,
                        -36.3286415
                    ]
                },
                "properties": {
                    "iqt": 305,
                    "kw": 2216.675,
                    "postcode": 3480
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        142.8312661,
                        -36.1476587
                    ]
                },
                "properties": {
                    "iqt": 50,
                    "kw": 511.6,
                    "postcode": 3482
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        142.8312661,
                        -35.9221523
                    ]
                },
                "properties": {
                    "iqt": 175,
                    "kw": 1071.14,
                    "postcode": 3483
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        142.7455935,
                        -35.6652195
                    ]
                },
                "properties": {
                    "iqt": 61,
                    "kw": 311.745,
                    "postcode": 3485
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        142.5959129,
                        -35.5546022
                    ]
                },
                "properties": {
                    "iqt": 17,
                    "kw": 85.87,
                    "postcode": 3487
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        142.4678659,
                        -35.4327537
                    ]
                },
                "properties": {
                    "iqt": 18,
                    "kw": 69.85,
                    "postcode": 3488
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        142.4039296,
                        -35.3151716
                    ]
                },
                "properties": {
                    "iqt": 10,
                    "kw": 141.995,
                    "postcode": 3489
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        141.5991643,
                        -35.3571245
                    ]
                },
                "properties": {
                    "iqt": 197,
                    "kw": 1538.395,
                    "postcode": 3490
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        142.1063337,
                        -35.394936
                    ]
                },
                "properties": {
                    "iqt": 29,
                    "kw": 159.93,
                    "postcode": 3491
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        142.1487691,
                        -34.540636
                    ]
                },
                "properties": {
                    "iqt": 92,
                    "kw": 1038.822,
                    "postcode": 3494
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        141.4309582,
                        -34.3907124
                    ]
                },
                "properties": {
                    "iqt": 1083,
                    "kw": 8337.604,
                    "postcode": 3496
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        142.159382,
                        -34.2495272
                    ]
                },
                "properties": {
                    "iqt": 947,
                    "kw": 8317.796,
                    "postcode": 3498
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        142.1169401,
                        -34.2151229
                    ]
                },
                "properties": {
                    "iqt": 4552,
                    "kw": 34257.933,
                    "postcode": 3500
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        142.318772,
                        -34.678204
                    ]
                },
                "properties": {
                    "iqt": 459,
                    "kw": 4007.391,
                    "postcode": 3501
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        133.775136,
                        -25.274398
                    ]
                },
                "properties": {
                    "iqt": 53,
                    "kw": 337.295,
                    "postcode": 3502
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        141.8100218,
                        -34.189156
                    ]
                },
                "properties": {
                    "iqt": 855,
                    "kw": 6558.215,
                    "postcode": 3505
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        141.3679914,
                        -35.1766811
                    ]
                },
                "properties": {
                    "iqt": 3,
                    "kw": 10.42,
                    "postcode": 3506
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        142.0639245,
                        -35.115573
                    ]
                },
                "properties": {
                    "iqt": 31,
                    "kw": 150.565,
                    "postcode": 3507
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        141.7255991,
                        -35.1414078
                    ]
                },
                "properties": {
                    "iqt": 50,
                    "kw": 244.79,
                    "postcode": 3509
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        141.095836,
                        -35.1673606
                    ]
                },
                "properties": {
                    "iqt": 72,
                    "kw": 344.235,
                    "postcode": 3512
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.0630048,
                        -36.8284445
                    ]
                },
                "properties": {
                    "iqt": 430,
                    "kw": 2673.76,
                    "postcode": 3515
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.0194472,
                        -36.6251143
                    ]
                },
                "properties": {
                    "iqt": 144,
                    "kw": 880.14,
                    "postcode": 3516
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        143.8671868,
                        -36.515547
                    ]
                },
                "properties": {
                    "iqt": 360,
                    "kw": 2016.973,
                    "postcode": 3517
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        143.6068646,
                        -36.424265
                    ]
                },
                "properties": {
                    "iqt": 305,
                    "kw": 1487.009,
                    "postcode": 3518
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        143.7694626,
                        -36.3588489
                    ]
                },
                "properties": {
                    "iqt": 42,
                    "kw": 170.24,
                    "postcode": 3520
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.851121,
                        -37.0989702
                    ]
                },
                "properties": {
                    "iqt": 139,
                    "kw": 765.482,
                    "postcode": 3521
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.7631754,
                        -37.0314398
                    ]
                },
                "properties": {
                    "iqt": 90,
                    "kw": 451.977,
                    "postcode": 3522
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.7412036,
                        -36.8919051
                    ]
                },
                "properties": {
                    "iqt": 963,
                    "kw": 5142.231,
                    "postcode": 3523
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        143.4338092,
                        -36.2125211
                    ]
                },
                "properties": {
                    "iqt": 287,
                    "kw": 1718.628,
                    "postcode": 3525
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        143.2611514,
                        -36.0005012
                    ]
                },
                "properties": {
                    "iqt": 138,
                    "kw": 783.578,
                    "postcode": 3527
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        143.1965079,
                        -35.845391
                    ]
                },
                "properties": {
                    "iqt": 17,
                    "kw": 103.54,
                    "postcode": 3529
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        143.1534436,
                        -35.7166782
                    ]
                },
                "properties": {
                    "iqt": 22,
                    "kw": 126.085,
                    "postcode": 3530
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        142.9170407,
                        -35.6512854
                    ]
                },
                "properties": {
                    "iqt": 26,
                    "kw": 117.55,
                    "postcode": 3531
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        142.7884171,
                        -35.3404178
                    ]
                },
                "properties": {
                    "iqt": 151,
                    "kw": 1049.655,
                    "postcode": 3533
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        143.6935405,
                        -36.0772722
                    ]
                },
                "properties": {
                    "iqt": 208,
                    "kw": 1456.231,
                    "postcode": 3537
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        143.5202874,
                        -35.8651458
                    ]
                },
                "properties": {
                    "iqt": 70,
                    "kw": 310.1,
                    "postcode": 3540
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        143.4122052,
                        -35.6565961
                    ]
                },
                "properties": {
                    "iqt": 32,
                    "kw": 185.72,
                    "postcode": 3542
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        143.1749726,
                        -35.4401221
                    ]
                },
                "properties": {
                    "iqt": 56,
                    "kw": 345.705,
                    "postcode": 3544
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        142.9599661,
                        -35.0979662
                    ]
                },
                "properties": {
                    "iqt": 83,
                    "kw": 473.7,
                    "postcode": 3546
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        142.7455935,
                        -34.7552395
                    ]
                },
                "properties": {
                    "iqt": 503,
                    "kw": 8164.034,
                    "postcode": 3549
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.2920769,
                        -36.7665875
                    ]
                },
                "properties": {
                    "iqt": 5059,
                    "kw": 29702.629,
                    "postcode": 3550
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.4779988,
                        -36.8021738
                    ]
                },
                "properties": {
                    "iqt": 6273,
                    "kw": 37704.381,
                    "postcode": 3551
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        133.775136,
                        -25.274398
                    ]
                },
                "properties": {
                    "iqt": 22,
                    "kw": 84.815,
                    "postcode": 3552
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        133.775136,
                        -25.274398
                    ]
                },
                "properties": {
                    "iqt": 2,
                    "kw": 6.39,
                    "postcode": 3554
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.2483931,
                        -36.808032
                    ]
                },
                "properties": {
                    "iqt": 2743,
                    "kw": 14888.807,
                    "postcode": 3555
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.1938221,
                        -36.6478425
                    ]
                },
                "properties": {
                    "iqt": 2060,
                    "kw": 10089.243,
                    "postcode": 3556
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.5437205,
                        -36.6546373
                    ]
                },
                "properties": {
                    "iqt": 150,
                    "kw": 843.609,
                    "postcode": 3557
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.5875645,
                        -36.4802144
                    ]
                },
                "properties": {
                    "iqt": 200,
                    "kw": 991.694,
                    "postcode": 3558
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.8291259,
                        -36.5430106
                    ]
                },
                "properties": {
                    "iqt": 76,
                    "kw": 603.965,
                    "postcode": 3559
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.6533747,
                        -36.3317046
                    ]
                },
                "properties": {
                    "iqt": 963,
                    "kw": 6673.571,
                    "postcode": 3561
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.5437205,
                        -36.0471946
                    ]
                },
                "properties": {
                    "iqt": 74,
                    "kw": 726.025,
                    "postcode": 3562
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.4999001,
                        -36.2606223
                    ]
                },
                "properties": {
                    "iqt": 173,
                    "kw": 1127.78,
                    "postcode": 3563
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.6314321,
                        -36.1149809
                    ]
                },
                "properties": {
                    "iqt": 3214,
                    "kw": 20918.817,
                    "postcode": 3564
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.5327632,
                        -36.186252
                    ]
                },
                "properties": {
                    "iqt": 17,
                    "kw": 169.535,
                    "postcode": 3565
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.3576473,
                        -35.9553896
                    ]
                },
                "properties": {
                    "iqt": 122,
                    "kw": 1033.345,
                    "postcode": 3566
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.2374759,
                        -35.9048344
                    ]
                },
                "properties": {
                    "iqt": 146,
                    "kw": 1828.29,
                    "postcode": 3567
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.215646,
                        -35.8021206
                    ]
                },
                "properties": {
                    "iqt": 629,
                    "kw": 5115.445,
                    "postcode": 3568
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.3904526,
                        -36.469814
                    ]
                },
                "properties": {
                    "iqt": 180,
                    "kw": 801.695,
                    "postcode": 3570
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.1283863,
                        -36.3797092
                    ]
                },
                "properties": {
                    "iqt": 76,
                    "kw": 557.952,
                    "postcode": 3571
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.3248554,
                        -36.3147326
                    ]
                },
                "properties": {
                    "iqt": 27,
                    "kw": 513.87,
                    "postcode": 3572
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.3904526,
                        -36.1663341
                    ]
                },
                "properties": {
                    "iqt": 68,
                    "kw": 739.98,
                    "postcode": 3573
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.1283863,
                        -36.0765288
                    ]
                },
                "properties": {
                    "iqt": 158,
                    "kw": 1104.76,
                    "postcode": 3575
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        143.9324048,
                        -36.1415403
                    ]
                },
                "properties": {
                    "iqt": 15,
                    "kw": 203.952,
                    "postcode": 3576
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        143.8671868,
                        -35.7583662
                    ]
                },
                "properties": {
                    "iqt": 1060,
                    "kw": 7526.428,
                    "postcode": 3579
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.1174856,
                        -35.6445701
                    ]
                },
                "properties": {
                    "iqt": 230,
                    "kw": 1457.35,
                    "postcode": 3580
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        143.8020236,
                        -35.6026039
                    ]
                },
                "properties": {
                    "iqt": 46,
                    "kw": 270.525,
                    "postcode": 3581
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        143.6827007,
                        -35.5135995
                    ]
                },
                "properties": {
                    "iqt": 32,
                    "kw": 290.19,
                    "postcode": 3583
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        143.6285244,
                        -35.4661938
                    ]
                },
                "properties": {
                    "iqt": 200,
                    "kw": 1587.85,
                    "postcode": 3584
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        143.5202874,
                        -35.4094202
                    ]
                },
                "properties": {
                    "iqt": 1740,
                    "kw": 13367.687,
                    "postcode": 3585
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        143.5094722,
                        -35.2818109
                    ]
                },
                "properties": {
                    "iqt": 127,
                    "kw": 1029.548,
                    "postcode": 3586
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        143.4446136,
                        -35.2972762
                    ]
                },
                "properties": {
                    "iqt": 92,
                    "kw": 631.855,
                    "postcode": 3588
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        143.4662269,
                        -35.2667175
                    ]
                },
                "properties": {
                    "iqt": 56,
                    "kw": 804.488,
                    "postcode": 3589
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        143.4662269,
                        -35.2285875
                    ]
                },
                "properties": {
                    "iqt": 56,
                    "kw": 571.72,
                    "postcode": 3590
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        143.4014055,
                        -35.205935
                    ]
                },
                "properties": {
                    "iqt": 33,
                    "kw": 232.585,
                    "postcode": 3591
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        143.3582223,
                        -35.1526896
                    ]
                },
                "properties": {
                    "iqt": 145,
                    "kw": 771.815,
                    "postcode": 3594
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        143.3366401,
                        -35.1832549
                    ]
                },
                "properties": {
                    "iqt": 147,
                    "kw": 669.245,
                    "postcode": 3595
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        143.2827118,
                        -35.1548064
                    ]
                },
                "properties": {
                    "iqt": 18,
                    "kw": 403.815,
                    "postcode": 3596
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        143.1749726,
                        -34.9071543
                    ]
                },
                "properties": {
                    "iqt": 81,
                    "kw": 1498.017,
                    "postcode": 3597
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        143.1104044,
                        -34.7507483
                    ]
                },
                "properties": {
                    "iqt": 28,
                    "kw": 512.045,
                    "postcode": 3599
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.1706992,
                        -36.8378153
                    ]
                },
                "properties": {
                    "iqt": 27,
                    "kw": 510.255,
                    "postcode": 3607
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.1155133,
                        -36.7719697
                    ]
                },
                "properties": {
                    "iqt": 666,
                    "kw": 4084.835,
                    "postcode": 3608
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.2480193,
                        -36.5881288
                    ]
                },
                "properties": {
                    "iqt": 383,
                    "kw": 2499.414,
                    "postcode": 3610
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.005249,
                        -36.602205
                    ]
                },
                "properties": {
                    "iqt": 436,
                    "kw": 2141.36,
                    "postcode": 3612
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.325409,
                        -36.4899607
                    ]
                },
                "properties": {
                    "iqt": 232,
                    "kw": 1529.32,
                    "postcode": 3614
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.2038278,
                        -36.4591947
                    ]
                },
                "properties": {
                    "iqt": 1081,
                    "kw": 7177.785,
                    "postcode": 3616
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.1706992,
                        -36.4005389
                    ]
                },
                "properties": {
                    "iqt": 30,
                    "kw": 245.66,
                    "postcode": 3617
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.1706992,
                        -36.3624013
                    ]
                },
                "properties": {
                    "iqt": 166,
                    "kw": 1403.18,
                    "postcode": 3618
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        133.775136,
                        -25.274398
                    ]
                },
                "properties": {
                    "iqt": 84,
                    "kw": 417.29,
                    "postcode": 3619
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.093449,
                        -36.2508546
                    ]
                },
                "properties": {
                    "iqt": 1656,
                    "kw": 10782.337,
                    "postcode": 3620
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.9832134,
                        -36.2331845
                    ]
                },
                "properties": {
                    "iqt": 476,
                    "kw": 3356.08,
                    "postcode": 3621
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.8951287,
                        -36.2037168
                    ]
                },
                "properties": {
                    "iqt": 89,
                    "kw": 851.625,
                    "postcode": 3622
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.9832134,
                        -36.4617737
                    ]
                },
                "properties": {
                    "iqt": 203,
                    "kw": 1317.245,
                    "postcode": 3623
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.9501708,
                        -36.4031385
                    ]
                },
                "properties": {
                    "iqt": 128,
                    "kw": 1016.09,
                    "postcode": 3624
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.2922335,
                        -36.2976747
                    ]
                },
                "properties": {
                    "iqt": 1483,
                    "kw": 8668.549,
                    "postcode": 3629
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.5579927,
                        -36.4615673
                    ]
                },
                "properties": {
                    "iqt": 4518,
                    "kw": 26761.761,
                    "postcode": 3630
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.4693163,
                        -36.4324574
                    ]
                },
                "properties": {
                    "iqt": 2791,
                    "kw": 20247.598,
                    "postcode": 3631
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        133.775136,
                        -25.274398
                    ]
                },
                "properties": {
                    "iqt": 52,
                    "kw": 623.705,
                    "postcode": 3632
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.480396,
                        -36.2927129
                    ]
                },
                "properties": {
                    "iqt": 138,
                    "kw": 728.63,
                    "postcode": 3633
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.4250118,
                        -36.2266803
                    ]
                },
                "properties": {
                    "iqt": 384,
                    "kw": 2677.222,
                    "postcode": 3634
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.3364703,
                        -36.1592629
                    ]
                },
                "properties": {
                    "iqt": 139,
                    "kw": 977.835,
                    "postcode": 3635
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.5136433,
                        -36.102425
                    ]
                },
                "properties": {
                    "iqt": 1159,
                    "kw": 6832.56,
                    "postcode": 3636
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.2922335,
                        -35.9530351
                    ]
                },
                "properties": {
                    "iqt": 132,
                    "kw": 1148.642,
                    "postcode": 3637
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.2038278,
                        -36.0388917
                    ]
                },
                "properties": {
                    "iqt": 460,
                    "kw": 3272.425,
                    "postcode": 3638
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.005249,
                        -35.9921604
                    ]
                },
                "properties": {
                    "iqt": 150,
                    "kw": 1209.473,
                    "postcode": 3639
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.4693163,
                        -36.0111562
                    ]
                },
                "properties": {
                    "iqt": 279,
                    "kw": 3084.985,
                    "postcode": 3640
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.4471613,
                        -35.9078595
                    ]
                },
                "properties": {
                    "iqt": 286,
                    "kw": 2086.755,
                    "postcode": 3641
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        133.775136,
                        -25.274398
                    ]
                },
                "properties": {
                    "iqt": 41,
                    "kw": 206.2,
                    "postcode": 3643
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.736481,
                        -35.9546799
                    ]
                },
                "properties": {
                    "iqt": 1995,
                    "kw": 15366.677,
                    "postcode": 3644
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.7133909,
                        -36.2251044
                    ]
                },
                "properties": {
                    "iqt": 133,
                    "kw": 668.93,
                    "postcode": 3646
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.6967281,
                        -36.3969441
                    ]
                },
                "properties": {
                    "iqt": 2,
                    "kw": 34.95,
                    "postcode": 3647
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.6911745,
                        -36.0834857
                    ]
                },
                "properties": {
                    "iqt": 94,
                    "kw": 527.92,
                    "postcode": 3649
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.093449,
                        -37.2372916
                    ]
                },
                "properties": {
                    "iqt": 1177,
                    "kw": 6396.007,
                    "postcode": 3658
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.1155133,
                        -37.1126329
                    ]
                },
                "properties": {
                    "iqt": 186,
                    "kw": 1085.35,
                    "postcode": 3659
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.2480193,
                        -37.0435482
                    ]
                },
                "properties": {
                    "iqt": 1285,
                    "kw": 7369.741,
                    "postcode": 3660
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        133.775136,
                        -25.274398
                    ]
                },
                "properties": {
                    "iqt": 37,
                    "kw": 114.304,
                    "postcode": 3661
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.9171412,
                        -36.9514451
                    ]
                },
                "properties": {
                    "iqt": 8,
                    "kw": 89.09,
                    "postcode": 3662
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.1596592,
                        -36.9383316
                    ]
                },
                "properties": {
                    "iqt": 60,
                    "kw": 425.302,
                    "postcode": 3663
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.3364703,
                        -36.9214551
                    ]
                },
                "properties": {
                    "iqt": 283,
                    "kw": 1610.827,
                    "postcode": 3664
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.3807298,
                        -36.8222633
                    ]
                },
                "properties": {
                    "iqt": 101,
                    "kw": 486.36,
                    "postcode": 3665
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.5801757,
                        -36.7549385
                    ]
                },
                "properties": {
                    "iqt": 1149,
                    "kw": 6472.13,
                    "postcode": 3666
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.7133909,
                        -36.6078959
                    ]
                },
                "properties": {
                    "iqt": 330,
                    "kw": 1662.543,
                    "postcode": 3669
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.8690603,
                        -36.6394628
                    ]
                },
                "properties": {
                    "iqt": 151,
                    "kw": 701.345,
                    "postcode": 3670
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        133.775136,
                        -25.274398
                    ]
                },
                "properties": {
                    "iqt": 86,
                    "kw": 454.34,
                    "postcode": 3671
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.9804173,
                        -36.6181709
                    ]
                },
                "properties": {
                    "iqt": 1845,
                    "kw": 10865.835,
                    "postcode": 3672
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        146.1588712,
                        -36.675664
                    ]
                },
                "properties": {
                    "iqt": 438,
                    "kw": 2391.1,
                    "postcode": 3673
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        146.1812023,
                        -36.5103613
                    ]
                },
                "properties": {
                    "iqt": 495,
                    "kw": 2605.48,
                    "postcode": 3675
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        133.775136,
                        -25.274398
                    ]
                },
                "properties": {
                    "iqt": 147,
                    "kw": 608.7,
                    "postcode": 3676
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        146.3264849,
                        -36.3742363
                    ]
                },
                "properties": {
                    "iqt": 2980,
                    "kw": 17217.688,
                    "postcode": 3677
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        146.5168094,
                        -36.7132294
                    ]
                },
                "properties": {
                    "iqt": 1671,
                    "kw": 10533.274,
                    "postcode": 3678
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        146.4495924,
                        -36.1723841
                    ]
                },
                "properties": {
                    "iqt": 162,
                    "kw": 1041.677,
                    "postcode": 3682
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        146.5840737,
                        -36.1761422
                    ]
                },
                "properties": {
                    "iqt": 409,
                    "kw": 1937.055,
                    "postcode": 3683
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        146.4495924,
                        -36.0564816
                    ]
                },
                "properties": {
                    "iqt": 716,
                    "kw": 4660.871,
                    "postcode": 3685
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        146.4383942,
                        -35.9852648
                    ]
                },
                "properties": {
                    "iqt": 244,
                    "kw": 1157.751,
                    "postcode": 3687
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        146.7299747,
                        -36.1542047
                    ]
                },
                "properties": {
                    "iqt": 335,
                    "kw": 1762.036,
                    "postcode": 3688
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        133.775136,
                        -25.274398
                    ]
                },
                "properties": {
                    "iqt": 101,
                    "kw": 374.121,
                    "postcode": 3689
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        146.8423556,
                        -36.1118041
                    ]
                },
                "properties": {
                    "iqt": 5382,
                    "kw": 32520.462,
                    "postcode": 3690
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        146.9661233,
                        -36.2373927
                    ]
                },
                "properties": {
                    "iqt": 2485,
                    "kw": 16192.075,
                    "postcode": 3691
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        133.775136,
                        -25.274398
                    ]
                },
                "properties": {
                    "iqt": 15,
                    "kw": 97.894,
                    "postcode": 3694
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.1238691,
                        -36.3055342
                    ]
                },
                "properties": {
                    "iqt": 102,
                    "kw": 556.398,
                    "postcode": 3695
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.168985,
                        -36.6673311
                    ]
                },
                "properties": {
                    "iqt": 142,
                    "kw": 775.99,
                    "postcode": 3697
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.1351462,
                        -36.762851
                    ]
                },
                "properties": {
                    "iqt": 264,
                    "kw": 1288.151,
                    "postcode": 3698
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.3270485,
                        -36.8124613
                    ]
                },
                "properties": {
                    "iqt": 181,
                    "kw": 1112.18,
                    "postcode": 3699
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.168985,
                        -36.2031354
                    ]
                },
                "properties": {
                    "iqt": 313,
                    "kw": 1946.043,
                    "postcode": 3700
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.3722545,
                        -36.5560587
                    ]
                },
                "properties": {
                    "iqt": 318,
                    "kw": 2272.628,
                    "postcode": 3701
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.5306312,
                        -36.1192035
                    ]
                },
                "properties": {
                    "iqt": 10,
                    "kw": 52.065,
                    "postcode": 3704
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.8026919,
                        -36.1622621
                    ]
                },
                "properties": {
                    "iqt": 69,
                    "kw": 376.433,
                    "postcode": 3705
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.9162555,
                        -36.4104992
                    ]
                },
                "properties": {
                    "iqt": 469,
                    "kw": 2502.374,
                    "postcode": 3707
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.9048938,
                        -36.0660058
                    ]
                },
                "properties": {
                    "iqt": 20,
                    "kw": 104.145,
                    "postcode": 3708
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.6892483,
                        -36.0696807
                    ]
                },
                "properties": {
                    "iqt": 100,
                    "kw": 591.733,
                    "postcode": 3709
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.702282,
                        -37.430404
                    ]
                },
                "properties": {
                    "iqt": 149,
                    "kw": 740.055,
                    "postcode": 3711
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.8245558,
                        -37.3476485
                    ]
                },
                "properties": {
                    "iqt": 77,
                    "kw": 765.03,
                    "postcode": 3712
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.9804173,
                        -37.3038068
                    ]
                },
                "properties": {
                    "iqt": 250,
                    "kw": 1285.115,
                    "postcode": 3713
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.6245586,
                        -37.1872994
                    ]
                },
                "properties": {
                    "iqt": 759,
                    "kw": 4335.788,
                    "postcode": 3714
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.7356129,
                        -36.9771194
                    ]
                },
                "properties": {
                    "iqt": 78,
                    "kw": 428.518,
                    "postcode": 3715
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.402868,
                        -37.3030137
                    ]
                },
                "properties": {
                    "iqt": 740,
                    "kw": 4234.956,
                    "postcode": 3717
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.5136433,
                        -37.1696241
                    ]
                },
                "properties": {
                    "iqt": 23,
                    "kw": 129.43,
                    "postcode": 3718
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.6023644,
                        -37.0473079
                    ]
                },
                "properties": {
                    "iqt": 126,
                    "kw": 749.82,
                    "postcode": 3719
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.8690603,
                        -37.0207039
                    ]
                },
                "properties": {
                    "iqt": 198,
                    "kw": 1320.952,
                    "postcode": 3720
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        146.1365456,
                        -37.0313019
                    ]
                },
                "properties": {
                    "iqt": 1219,
                    "kw": 8545.721,
                    "postcode": 3722
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        146.2929381,
                        -37.2909944
                    ]
                },
                "properties": {
                    "iqt": 735,
                    "kw": 4433.567,
                    "postcode": 3723
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        133.775136,
                        -25.274398
                    ]
                },
                "properties": {
                    "iqt": 18,
                    "kw": 152.945,
                    "postcode": 3724
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.958135,
                        -36.4002774
                    ]
                },
                "properties": {
                    "iqt": 149,
                    "kw": 795.37,
                    "postcode": 3725
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        146.002705,
                        -36.3378842
                    ]
                },
                "properties": {
                    "iqt": 101,
                    "kw": 473.785,
                    "postcode": 3726
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.958135,
                        -36.2467001
                    ]
                },
                "properties": {
                    "iqt": 77,
                    "kw": 323.66,
                    "postcode": 3727
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.9135867,
                        -36.1554528
                    ]
                },
                "properties": {
                    "iqt": 159,
                    "kw": 787.5,
                    "postcode": 3728
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.8913207,
                        -36.0520717
                    ]
                },
                "properties": {
                    "iqt": 2224,
                    "kw": 12938.778,
                    "postcode": 3730
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        146.3153013,
                        -36.7449213
                    ]
                },
                "properties": {
                    "iqt": 153,
                    "kw": 832.702,
                    "postcode": 3732
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        146.4160017,
                        -36.748307
                    ]
                },
                "properties": {
                    "iqt": 48,
                    "kw": 354.865,
                    "postcode": 3733
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        146.5840737,
                        -36.5231859
                    ]
                },
                "properties": {
                    "iqt": 115,
                    "kw": 798.52,
                    "postcode": 3735
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        133.775136,
                        -25.274398
                    ]
                },
                "properties": {
                    "iqt": 33,
                    "kw": 142.04,
                    "postcode": 3736
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        146.6962857,
                        -36.8466834
                    ]
                },
                "properties": {
                    "iqt": 825,
                    "kw": 5149.861,
                    "postcode": 3737
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        146.7749116,
                        -36.6120774
                    ]
                },
                "properties": {
                    "iqt": 43,
                    "kw": 257.29,
                    "postcode": 3738
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        146.8423556,
                        -36.6332007
                    ]
                },
                "properties": {
                    "iqt": 48,
                    "kw": 425.67,
                    "postcode": 3739
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        146.8760951,
                        -36.8264122
                    ]
                },
                "properties": {
                    "iqt": 243,
                    "kw": 1286.029,
                    "postcode": 3740
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.0562333,
                        -36.882628
                    ]
                },
                "properties": {
                    "iqt": 740,
                    "kw": 4295.36,
                    "postcode": 3741
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        146.9773826,
                        -36.7907956
                    ]
                },
                "properties": {
                    "iqt": 110,
                    "kw": 547.454,
                    "postcode": 3744
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        146.5280168,
                        -36.3225392
                    ]
                },
                "properties": {
                    "iqt": 122,
                    "kw": 536.524,
                    "postcode": 3746
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        146.6962857,
                        -36.3851254
                    ]
                },
                "properties": {
                    "iqt": 1185,
                    "kw": 6333.094,
                    "postcode": 3747
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        146.8536008,
                        -36.3378001
                    ]
                },
                "properties": {
                    "iqt": 603,
                    "kw": 3185.702,
                    "postcode": 3749
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.9942305,
                        -37.5891893
                    ]
                },
                "properties": {
                    "iqt": 3397,
                    "kw": 21893.92,
                    "postcode": 3750
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.0603633,
                        -37.5365105
                    ]
                },
                "properties": {
                    "iqt": 16,
                    "kw": 150.51,
                    "postcode": 3751
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.082419,
                        -37.6377485
                    ]
                },
                "properties": {
                    "iqt": 2625,
                    "kw": 13938.351,
                    "postcode": 3752
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.9832134,
                        -37.4822825
                    ]
                },
                "properties": {
                    "iqt": 623,
                    "kw": 4048.567,
                    "postcode": 3753
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.1265477,
                        -37.5963626
                    ]
                },
                "properties": {
                    "iqt": 5829,
                    "kw": 32302.4,
                    "postcode": 3754
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.1486206,
                        -37.5474779
                    ]
                },
                "properties": {
                    "iqt": 36,
                    "kw": 232.89,
                    "postcode": 3755
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.9832134,
                        -37.4071549
                    ]
                },
                "properties": {
                    "iqt": 2172,
                    "kw": 12189.506,
                    "postcode": 3756
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.1596592,
                        -37.4666309
                    ]
                },
                "properties": {
                    "iqt": 1320,
                    "kw": 7893.169,
                    "postcode": 3757
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.0383133,
                        -37.3787648
                    ]
                },
                "properties": {
                    "iqt": 361,
                    "kw": 1977.444,
                    "postcode": 3758
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.2424941,
                        -37.6400391
                    ]
                },
                "properties": {
                    "iqt": 202,
                    "kw": 1259.844,
                    "postcode": 3759
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.2867055,
                        -37.6267001
                    ]
                },
                "properties": {
                    "iqt": 68,
                    "kw": 339.641,
                    "postcode": 3760
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.2811778,
                        -37.5919774
                    ]
                },
                "properties": {
                    "iqt": 226,
                    "kw": 1287.177,
                    "postcode": 3761
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.9721978,
                        -37.3564385
                    ]
                },
                "properties": {
                    "iqt": 23,
                    "kw": 140.935,
                    "postcode": 3762
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.3696628,
                        -37.5087273
                    ]
                },
                "properties": {
                    "iqt": 337,
                    "kw": 1744.727,
                    "postcode": 3763
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.9171412,
                        -37.2531649
                    ]
                },
                "properties": {
                    "iqt": 1423,
                    "kw": 8014.532,
                    "postcode": 3764
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.353065,
                        -37.8083883
                    ]
                },
                "properties": {
                    "iqt": 689,
                    "kw": 3808.964,
                    "postcode": 3765
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.3862638,
                        -37.8194936
                    ]
                },
                "properties": {
                    "iqt": 110,
                    "kw": 573.49,
                    "postcode": 3766
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.3420015,
                        -37.8421584
                    ]
                },
                "properties": {
                    "iqt": 69,
                    "kw": 390.335,
                    "postcode": 3767
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.4250118,
                        -37.7057909
                    ]
                },
                "properties": {
                    "iqt": 480,
                    "kw": 4132.683,
                    "postcode": 3770
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.3807298,
                        -37.6158673
                    ]
                },
                "properties": {
                    "iqt": 629,
                    "kw": 4220.343,
                    "postcode": 3775
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.5136433,
                        -37.5848772
                    ]
                },
                "properties": {
                    "iqt": 1524,
                    "kw": 8823.404,
                    "postcode": 3777
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.6467583,
                        -37.553614
                    ]
                },
                "properties": {
                    "iqt": 45,
                    "kw": 228.82,
                    "postcode": 3778
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        146.0696009,
                        -37.6356131
                    ]
                },
                "properties": {
                    "iqt": 135,
                    "kw": 942.865,
                    "postcode": 3779
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.5025595,
                        -37.9473069
                    ]
                },
                "properties": {
                    "iqt": 438,
                    "kw": 2170.112,
                    "postcode": 3781
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.4582381,
                        -37.9137981
                    ]
                },
                "properties": {
                    "iqt": 895,
                    "kw": 4794.958,
                    "postcode": 3782
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.6023644,
                        -37.9524044
                    ]
                },
                "properties": {
                    "iqt": 343,
                    "kw": 1993.506,
                    "postcode": 3783
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.3171139,
                        -37.8782906
                    ]
                },
                "properties": {
                    "iqt": 2,
                    "kw": 11.98,
                    "postcode": 3785
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.3309395,
                        -37.8759058
                    ]
                },
                "properties": {
                    "iqt": 139,
                    "kw": 787.385,
                    "postcode": 3786
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.353065,
                        -37.8645935
                    ]
                },
                "properties": {
                    "iqt": 61,
                    "kw": 329.36,
                    "postcode": 3787
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.3751961,
                        -37.8532703
                    ]
                },
                "properties": {
                    "iqt": 140,
                    "kw": 819.416,
                    "postcode": 3788
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.3641298,
                        -37.8963853
                    ]
                },
                "properties": {
                    "iqt": 18,
                    "kw": 124.57,
                    "postcode": 3789
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.4111713,
                        -37.9051015
                    ]
                },
                "properties": {
                    "iqt": 125,
                    "kw": 787.413,
                    "postcode": 3791
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.3973329,
                        -37.8887708
                    ]
                },
                "properties": {
                    "iqt": 114,
                    "kw": 614.529,
                    "postcode": 3792
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.4360858,
                        -37.8689357
                    ]
                },
                "properties": {
                    "iqt": 443,
                    "kw": 3100.467,
                    "postcode": 3793
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.4305486,
                        -37.8342877
                    ]
                },
                "properties": {
                    "iqt": 221,
                    "kw": 1879.876,
                    "postcode": 3795
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.3917982,
                        -37.7791563
                    ]
                },
                "properties": {
                    "iqt": 998,
                    "kw": 5095.036,
                    "postcode": 3796
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.702282,
                        -37.8447909
                    ]
                },
                "properties": {
                    "iqt": 504,
                    "kw": 3035.08,
                    "postcode": 3797
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.8023118,
                        -37.6990844
                    ]
                },
                "properties": {
                    "iqt": 814,
                    "kw": 4173.916,
                    "postcode": 3799
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.2590707,
                        -37.9780214
                    ]
                },
                "properties": {
                    "iqt": 2928,
                    "kw": 13595.057,
                    "postcode": 3802
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.2756505,
                        -38.0069505
                    ]
                },
                "properties": {
                    "iqt": 1490,
                    "kw": 11074.166,
                    "postcode": 3803
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.3309395,
                        -37.9788019
                    ]
                },
                "properties": {
                    "iqt": 1166,
                    "kw": 8053.532,
                    "postcode": 3804
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.3032906,
                        -38.0302499
                    ]
                },
                "properties": {
                    "iqt": 7490,
                    "kw": 36922.446,
                    "postcode": 3805
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.3475331,
                        -38.0264207
                    ]
                },
                "properties": {
                    "iqt": 6539,
                    "kw": 34625.182,
                    "postcode": 3806
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.3862638,
                        -38.0347309
                    ]
                },
                "properties": {
                    "iqt": 979,
                    "kw": 5544.548,
                    "postcode": 3807
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.4360858,
                        -37.999986
                    ]
                },
                "properties": {
                    "iqt": 454,
                    "kw": 3027.568,
                    "postcode": 3808
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.4139392,
                        -38.0673549
                    ]
                },
                "properties": {
                    "iqt": 2666,
                    "kw": 17293.938,
                    "postcode": 3809
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.4693163,
                        -38.0578366
                    ]
                },
                "properties": {
                    "iqt": 6656,
                    "kw": 38178.496,
                    "postcode": 3810
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.5690835,
                        -38.0817495
                    ]
                },
                "properties": {
                    "iqt": 337,
                    "kw": 2726.477,
                    "postcode": 3812
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.6356577,
                        -38.0477423
                    ]
                },
                "properties": {
                    "iqt": 142,
                    "kw": 1256.216,
                    "postcode": 3813
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.6800684,
                        -38.0999051
                    ]
                },
                "properties": {
                    "iqt": 347,
                    "kw": 2280.149,
                    "postcode": 3814
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.7245012,
                        -38.0771825
                    ]
                },
                "properties": {
                    "iqt": 478,
                    "kw": 2875.7,
                    "postcode": 3815
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.7800733,
                        -38.086187
                    ]
                },
                "properties": {
                    "iqt": 469,
                    "kw": 3046.371,
                    "postcode": 3816
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.8690603,
                        -38.1155251
                    ]
                },
                "properties": {
                    "iqt": 2634,
                    "kw": 14045.938,
                    "postcode": 3818
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.9469958,
                        -38.1692482
                    ]
                },
                "properties": {
                    "iqt": 2607,
                    "kw": 14903.301,
                    "postcode": 3820
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        146.002705,
                        -38.0844084
                    ]
                },
                "properties": {
                    "iqt": 537,
                    "kw": 3558.008,
                    "postcode": 3821
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        146.0361469,
                        -38.1797383
                    ]
                },
                "properties": {
                    "iqt": 154,
                    "kw": 901.468,
                    "postcode": 3822
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        146.0584482,
                        -38.2245094
                    ]
                },
                "properties": {
                    "iqt": 423,
                    "kw": 2483.962,
                    "postcode": 3823
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        146.1812023,
                        -38.2177192
                    ]
                },
                "properties": {
                    "iqt": 752,
                    "kw": 4251.541,
                    "postcode": 3824
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        146.2929381,
                        -38.0474021
                    ]
                },
                "properties": {
                    "iqt": 3028,
                    "kw": 15645.213,
                    "postcode": 3825
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        146.002705,
                        -38.0093215
                    ]
                },
                "properties": {
                    "iqt": 402,
                    "kw": 2197.035,
                    "postcode": 3831
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.9915605,
                        -37.9211096
                    ]
                },
                "properties": {
                    "iqt": 54,
                    "kw": 341.18,
                    "postcode": 3832
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        146.0696009,
                        -37.7865626
                    ]
                },
                "properties": {
                    "iqt": 72,
                    "kw": 451.546,
                    "postcode": 3833
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        146.1812023,
                        -38.2926842
                    ]
                },
                "properties": {
                    "iqt": 75,
                    "kw": 602.19,
                    "postcode": 3835
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        146.4495924,
                        -38.2671612
                    ]
                },
                "properties": {
                    "iqt": 2091,
                    "kw": 13705.227,
                    "postcode": 3840
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        146.4160017,
                        -38.3219988
                    ]
                },
                "properties": {
                    "iqt": 642,
                    "kw": 3156.117,
                    "postcode": 3842
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        146.5840737,
                        -38.2728501
                    ]
                },
                "properties": {
                    "iqt": 3834,
                    "kw": 23398.455,
                    "postcode": 3844
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        146.8086278,
                        -38.2317005
                    ]
                },
                "properties": {
                    "iqt": 396,
                    "kw": 2398.25,
                    "postcode": 3847
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.0675028,
                        -38.096577
                    ]
                },
                "properties": {
                    "iqt": 1822,
                    "kw": 11140.249,
                    "postcode": 3850
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.1464245,
                        -38.2064012
                    ]
                },
                "properties": {
                    "iqt": 1461,
                    "kw": 7429.377,
                    "postcode": 3851
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.1407852,
                        -38.1054124
                    ]
                },
                "properties": {
                    "iqt": 4,
                    "kw": 115.62,
                    "postcode": 3852
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        133.775136,
                        -25.274398
                    ]
                },
                "properties": {
                    "iqt": 9,
                    "kw": 36.365,
                    "postcode": 3853
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        146.5840737,
                        -38.1223546
                    ]
                },
                "properties": {
                    "iqt": 243,
                    "kw": 1404.01,
                    "postcode": 3854
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        146.5392256,
                        -38.0326139
                    ]
                },
                "properties": {
                    "iqt": 209,
                    "kw": 1246.09,
                    "postcode": 3856
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        146.6850587,
                        -38.0132354
                    ]
                },
                "properties": {
                    "iqt": 88,
                    "kw": 438.975,
                    "postcode": 3857
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        146.6513853,
                        -37.557605
                    ]
                },
                "properties": {
                    "iqt": 648,
                    "kw": 4722.124,
                    "postcode": 3858
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        146.8985944,
                        -37.920365
                    ]
                },
                "properties": {
                    "iqt": 182,
                    "kw": 1851.307,
                    "postcode": 3859
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        146.9661233,
                        -37.6951451
                    ]
                },
                "properties": {
                    "iqt": 1155,
                    "kw": 6643.215,
                    "postcode": 3860
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.1915504,
                        -37.4228208
                    ]
                },
                "properties": {
                    "iqt": 670,
                    "kw": 3841.626,
                    "postcode": 3862
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.304453,
                        -37.8199648
                    ]
                },
                "properties": {
                    "iqt": 50,
                    "kw": 312.156,
                    "postcode": 3864
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.468383,
                        -37.7994292
                    ]
                },
                "properties": {
                    "iqt": 122,
                    "kw": 913.309,
                    "postcode": 3865
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        146.3712327,
                        -38.3637637
                    ]
                },
                "properties": {
                    "iqt": 342,
                    "kw": 1897.108,
                    "postcode": 3869
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        146.3600438,
                        -38.4631226
                    ]
                },
                "properties": {
                    "iqt": 289,
                    "kw": 1229.638,
                    "postcode": 3870
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        146.1812023,
                        -38.4049813
                    ]
                },
                "properties": {
                    "iqt": 547,
                    "kw": 3037.121,
                    "postcode": 3871
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        146.6738329,
                        -38.3016024
                    ]
                },
                "properties": {
                    "iqt": 75,
                    "kw": 444.09,
                    "postcode": 3873
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        146.8985944,
                        -38.5234965
                    ]
                },
                "properties": {
                    "iqt": 159,
                    "kw": 850.725,
                    "postcode": 3874
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.5532762,
                        -37.6874281
                    ]
                },
                "properties": {
                    "iqt": 3280,
                    "kw": 19416.316,
                    "postcode": 3875
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.6779106,
                        -37.9067566
                    ]
                },
                "properties": {
                    "iqt": 305,
                    "kw": 1605.422,
                    "postcode": 3878
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.7573,
                        -37.9215501
                    ]
                },
                "properties": {
                    "iqt": 910,
                    "kw": 4313.896,
                    "postcode": 3880
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.7573,
                        -37.8071978
                    ]
                },
                "properties": {
                    "iqt": 274,
                    "kw": 1477.561,
                    "postcode": 3882
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        148.2804541,
                        -37.2938907
                    ]
                },
                "properties": {
                    "iqt": 413,
                    "kw": 1967.244,
                    "postcode": 3885
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        148.42875,
                        -37.7514308
                    ]
                },
                "properties": {
                    "iqt": 73,
                    "kw": 499.41,
                    "postcode": 3886
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        148.0299382,
                        -37.6989476
                    ]
                },
                "properties": {
                    "iqt": 109,
                    "kw": 643.599,
                    "postcode": 3887
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        148.6458369,
                        -37.2474912
                    ]
                },
                "properties": {
                    "iqt": 670,
                    "kw": 3554.274,
                    "postcode": 3888
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        148.8289611,
                        -37.609984
                    ]
                },
                "properties": {
                    "iqt": 44,
                    "kw": 219.714,
                    "postcode": 3889
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        149.1960526,
                        -37.5621735
                    ]
                },
                "properties": {
                    "iqt": 67,
                    "kw": 338.242,
                    "postcode": 3890
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        149.5642369,
                        -37.5126059
                    ]
                },
                "properties": {
                    "iqt": 45,
                    "kw": 174.965,
                    "postcode": 3891
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        149.7718067,
                        -37.5130708
                    ]
                },
                "properties": {
                    "iqt": 329,
                    "kw": 1462.422,
                    "postcode": 3892
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.8026919,
                        -37.4768667
                    ]
                },
                "properties": {
                    "iqt": 5,
                    "kw": 38.815,
                    "postcode": 3893
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.848103,
                        -37.3755587
                    ]
                },
                "properties": {
                    "iqt": 33,
                    "kw": 179.445,
                    "postcode": 3895
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.7799935,
                        -37.1819263
                    ]
                },
                "properties": {
                    "iqt": 66,
                    "kw": 385.425,
                    "postcode": 3896
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.5079912,
                        -37.022052
                    ]
                },
                "properties": {
                    "iqt": 143,
                    "kw": 841.726,
                    "postcode": 3898
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.8708157,
                        -36.9009009
                    ]
                },
                "properties": {
                    "iqt": 31,
                    "kw": 157.645,
                    "postcode": 3900
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.8140428,
                        -37.8149759
                    ]
                },
                "properties": {
                    "iqt": 79,
                    "kw": 430.762,
                    "postcode": 3902
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.8594587,
                        -37.8097254
                    ]
                },
                "properties": {
                    "iqt": 160,
                    "kw": 853.938,
                    "postcode": 3903
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.8367484,
                        -37.8600459
                    ]
                },
                "properties": {
                    "iqt": 437,
                    "kw": 2213.077,
                    "postcode": 3904
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        148.0299382,
                        -37.8136883
                    ]
                },
                "properties": {
                    "iqt": 1586,
                    "kw": 8489.245,
                    "postcode": 3909
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.1927835,
                        -38.1608986
                    ]
                },
                "properties": {
                    "iqt": 2714,
                    "kw": 13606.442,
                    "postcode": 3910
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.1762197,
                        -38.1972006
                    ]
                },
                "properties": {
                    "iqt": 488,
                    "kw": 3377.579,
                    "postcode": 3911
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.2148736,
                        -38.2242212
                    ]
                },
                "properties": {
                    "iqt": 2028,
                    "kw": 11539.58,
                    "postcode": 3912
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.1706992,
                        -38.2651079
                    ]
                },
                "properties": {
                    "iqt": 507,
                    "kw": 3239.406,
                    "postcode": 3913
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.1265477,
                        -38.3059216
                    ]
                },
                "properties": {
                    "iqt": 1317,
                    "kw": 8049.716,
                    "postcode": 3915
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.0548502,
                        -38.4161358
                    ]
                },
                "properties": {
                    "iqt": 269,
                    "kw": 1967.243,
                    "postcode": 3916
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.165179,
                        -38.3329437
                    ]
                },
                "properties": {
                    "iqt": 764,
                    "kw": 3853.118,
                    "postcode": 3918
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.1983055,
                        -38.3534427
                    ]
                },
                "properties": {
                    "iqt": 424,
                    "kw": 2042.515,
                    "postcode": 3919
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.3364703,
                        -38.3489348
                    ]
                },
                "properties": {
                    "iqt": 82,
                    "kw": 326.889,
                    "postcode": 3921
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.2038278,
                        -38.4898703
                    ]
                },
                "properties": {
                    "iqt": 2172,
                    "kw": 12928.769,
                    "postcode": 3922
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.2756505,
                        -38.4724137
                    ]
                },
                "properties": {
                    "iqt": 198,
                    "kw": 1004.362,
                    "postcode": 3923
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.3862638,
                        -38.5282425
                    ]
                },
                "properties": {
                    "iqt": 934,
                    "kw": 5750.921,
                    "postcode": 3925
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.1044805,
                        -38.3541527
                    ]
                },
                "properties": {
                    "iqt": 700,
                    "kw": 4295.201,
                    "postcode": 3926
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.165179,
                        -38.3793743
                    ]
                },
                "properties": {
                    "iqt": 401,
                    "kw": 2187.652,
                    "postcode": 3927
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.9721978,
                        -38.4018779
                    ]
                },
                "properties": {
                    "iqt": 114,
                    "kw": 1047.856,
                    "postcode": 3928
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.9721978,
                        -38.4574538
                    ]
                },
                "properties": {
                    "iqt": 330,
                    "kw": 2462.017,
                    "postcode": 3929
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.0879338,
                        -38.1952209
                    ]
                },
                "properties": {
                    "iqt": 2108,
                    "kw": 13019.186,
                    "postcode": 3930
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.0603633,
                        -38.2277083
                    ]
                },
                "properties": {
                    "iqt": 3081,
                    "kw": 15715.523,
                    "postcode": 3931
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.1265477,
                        -38.2501593
                    ]
                },
                "properties": {
                    "iqt": 170,
                    "kw": 1684.379,
                    "postcode": 3933
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.016269,
                        -38.287039
                    ]
                },
                "properties": {
                    "iqt": 2556,
                    "kw": 14047.374,
                    "postcode": 3934
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.9942305,
                        -38.3352183
                    ]
                },
                "properties": {
                    "iqt": 1668,
                    "kw": 9481.579,
                    "postcode": 3936
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.0383133,
                        -38.3687813
                    ]
                },
                "properties": {
                    "iqt": 334,
                    "kw": 2825.252,
                    "postcode": 3937
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.9336544,
                        -38.3562816
                    ]
                },
                "properties": {
                    "iqt": 525,
                    "kw": 2575.962,
                    "postcode": 3938
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.8951287,
                        -38.4218526
                    ]
                },
                "properties": {
                    "iqt": 2297,
                    "kw": 12620.907,
                    "postcode": 3939
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.8786231,
                        -38.3745297
                    ]
                },
                "properties": {
                    "iqt": 501,
                    "kw": 2576.866,
                    "postcode": 3940
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.8181305,
                        -38.3862088
                    ]
                },
                "properties": {
                    "iqt": 2094,
                    "kw": 11014.753,
                    "postcode": 3941
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.7686693,
                        -38.3645949
                    ]
                },
                "properties": {
                    "iqt": 563,
                    "kw": 3148.881,
                    "postcode": 3942
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.746696,
                        -38.3477833
                    ]
                },
                "properties": {
                    "iqt": 499,
                    "kw": 3077.61,
                    "postcode": 3943
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.7027669,
                        -38.3234069
                    ]
                },
                "properties": {
                    "iqt": 212,
                    "kw": 1764.338,
                    "postcode": 3944
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.6911745,
                        -38.3930465
                    ]
                },
                "properties": {
                    "iqt": 257,
                    "kw": 1526.291,
                    "postcode": 3945
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.7245012,
                        -38.4506894
                    ]
                },
                "properties": {
                    "iqt": 60,
                    "kw": 377.345,
                    "postcode": 3946
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.8245558,
                        -38.4372473
                    ]
                },
                "properties": {
                    "iqt": 805,
                    "kw": 4617.374,
                    "postcode": 3950
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.7356129,
                        -38.5195374
                    ]
                },
                "properties": {
                    "iqt": 223,
                    "kw": 1408.807,
                    "postcode": 3951
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        146.002705,
                        -38.4586497
                    ]
                },
                "properties": {
                    "iqt": 1274,
                    "kw": 7822.455,
                    "postcode": 3953
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.9469958,
                        -38.5615123
                    ]
                },
                "properties": {
                    "iqt": 82,
                    "kw": 414.05,
                    "postcode": 3954
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.8690603,
                        -38.675332
                    ]
                },
                "properties": {
                    "iqt": 866,
                    "kw": 4688.45,
                    "postcode": 3956
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        146.1030672,
                        -38.5941498
                    ]
                },
                "properties": {
                    "iqt": 64,
                    "kw": 577.422,
                    "postcode": 3957
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        146.013851,
                        -38.6765966
                    ]
                },
                "properties": {
                    "iqt": 41,
                    "kw": 247.501,
                    "postcode": 3958
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        146.0696009,
                        -38.760009
                    ]
                },
                "properties": {
                    "iqt": 433,
                    "kw": 2202.185,
                    "postcode": 3959
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        146.3376699,
                        -38.9962856
                    ]
                },
                "properties": {
                    "iqt": 664,
                    "kw": 3569.385,
                    "postcode": 3960
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        146.3488562,
                        -38.6183432
                    ]
                },
                "properties": {
                    "iqt": 225,
                    "kw": 1072.785,
                    "postcode": 3962
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        146.2733747,
                        -38.6847281
                    ]
                },
                "properties": {
                    "iqt": 33,
                    "kw": 150.295,
                    "postcode": 3964
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        146.4775937,
                        -38.692708
                    ]
                },
                "properties": {
                    "iqt": 71,
                    "kw": 393.376,
                    "postcode": 3965
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        146.4383942,
                        -38.6286899
                    ]
                },
                "properties": {
                    "iqt": 103,
                    "kw": 575.215,
                    "postcode": 3966
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        146.5392256,
                        -38.6705951
                    ]
                },
                "properties": {
                    "iqt": 32,
                    "kw": 178.26,
                    "postcode": 3967
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        146.6065057,
                        -38.5613687
                    ]
                },
                "properties": {
                    "iqt": 774,
                    "kw": 4207.692,
                    "postcode": 3971
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.2424941,
                        -38.0704681
                    ]
                },
                "properties": {
                    "iqt": 2980,
                    "kw": 15467.698,
                    "postcode": 3975
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.2756505,
                        -38.0349647
                    ]
                },
                "properties": {
                    "iqt": 3123,
                    "kw": 14048.307,
                    "postcode": 3976
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.2811778,
                        -38.1347885
                    ]
                },
                "properties": {
                    "iqt": 16077,
                    "kw": 86246.646,
                    "postcode": 3977
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.3807298,
                        -38.140252
                    ]
                },
                "properties": {
                    "iqt": 6949,
                    "kw": 45338.355,
                    "postcode": 3978
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.6134608,
                        -38.4509941
                    ]
                },
                "properties": {
                    "iqt": 74,
                    "kw": 440.65,
                    "postcode": 3979
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.3917982,
                        -38.2092442
                    ]
                },
                "properties": {
                    "iqt": 600,
                    "kw": 3362.347,
                    "postcode": 3980
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.5912693,
                        -38.1825837
                    ]
                },
                "properties": {
                    "iqt": 823,
                    "kw": 6090.728,
                    "postcode": 3981
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.5579927,
                        -38.3114378
                    ]
                },
                "properties": {
                    "iqt": 1437,
                    "kw": 8015.861,
                    "postcode": 3984
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.6800684,
                        -38.3054452
                    ]
                },
                "properties": {
                    "iqt": 288,
                    "kw": 1519.698,
                    "postcode": 3987
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.7800733,
                        -38.310594
                    ]
                },
                "properties": {
                    "iqt": 206,
                    "kw": 1285.79,
                    "postcode": 3988
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.5247285,
                        -38.4399786
                    ]
                },
                "properties": {
                    "iqt": 29,
                    "kw": 206.73,
                    "postcode": 3990
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.4582381,
                        -38.4734903
                    ]
                },
                "properties": {
                    "iqt": 115,
                    "kw": 629.162,
                    "postcode": 3991
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.6023644,
                        -38.5123976
                    ]
                },
                "properties": {
                    "iqt": 244,
                    "kw": 1437.255,
                    "postcode": 3992
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.6023644,
                        -38.6238593
                    ]
                },
                "properties": {
                    "iqt": 2235,
                    "kw": 12171.273,
                    "postcode": 3995
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.7800733,
                        -38.6086874
                    ]
                },
                "properties": {
                    "iqt": 1401,
                    "kw": 7496.969,
                    "postcode": 3996
                }
            }
        ]
    };
    let map;
    map = new google.maps.Map(document.getElementById("map"), {
        center: {
            lat: -37.840935,
            lng: 144.946457
        },
        zoom: 9
    });
    map.data.addGeoJson(solarData);
    const infowindow = new google.maps.InfoWindow();
    map.data.addListener("click", (event)=>{
        const iqt = event.feature.getProperty("iqt");
        const kw = event.feature.getProperty("kw");
        const postcode = event.feature.getProperty("postcode");
        const content = `<div><strong>Installations Quantity Total:</strong> ${iqt}</div><div><strong>SGU Rated Output In kW Total:</strong> ${kw}</div><div><strong>Postcode:</strong> ${postcode}</div>`;
        infowindow.setContent(content);
        infowindow.setPosition(event.latLng);
        infowindow.open(map);
    });
    map.data.setStyle((feature)=>{
        const dScale = Math.pow(Math.log(feature.getProperty("iqt")), 1.4);
        return {
            icon: {
                path: google.maps.SymbolPath.CIRCLE,
                scale: dScale,
                fillColor: "#f00",
                fillOpacity: 0.35,
                strokeColor: "#444",
                strokeWeight: 1
            }
        };
    });
}
window.initMap = initMap;

//# sourceMappingURL=household_info.457594f1.js.map
